<template>
  <div @click="goToPriceWatcherPage" class="home-button">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="home-button__icon">
          <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              height="256px"
              viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve"
          >
            <g>
	<path class="st404" d="M118.1,962.1c1.7,0.1,3.4,0.1,5.2,0.4c2.4,0.1,10.8,0.8,16,6.9c2.2,2.4,5.4,7.6,5.4,16.1
		c0,1.8-0.1,4.9-1.1,9.1c-0.9,3.4-2.7,10-9.8,15.2c-8.1,5.8-17.1,5.7-20.5,5.7c-3.3,0-6.5-0.3-9.9-0.6l-4.8-15.2
		c3.5,0.4,7.1,0.8,10.6,0.8c0.7,0,3.7,0,6.1-0.7c5.9-1.7,10.6-6.8,10.6-13c0-1-0.1-3.5-1.4-5.7c-2.4-4-6.4-4.4-15.7-4.1H96.6
		c-0.9,15.8-1.8,31.7-2.4,47.4c-0.4,9.6-0.7,19.1-0.8,28.6H73c0.6-4.7,1.1-9.5,1.4-14.1c0.6-7.1,0.8-14.1,1.1-21.3
		c0.6-8.7,1-17.3,1.3-26c0.3-9.9,0.4-19.6,0.7-29.5L118.1,962.1L118.1,962.1z"/>
              <path class="st693" d="M199.6,984c5.5,0.4,10.6,0.9,15.1,3.7c2.7,1.6,7.6,6.2,7.6,13.8c0,1-0.1,3.2-1,5.7
		c-0.9,2.6-3.6,8.8-11.6,12.7c-2.9,1.4-6.8,2.6-10,3.4l18.7,29.7h-21.2c-2-4.2-4-8.2-6.4-12.2c-2.3-4.1-4.7-8.1-7.2-12
		c-3-4.9-5.9-9.7-8.8-14.4c2.9,0.2,5.7,0.4,8.6,0.4c2.3,0,12.2-0.1,17.1-5.5c2.3-2.6,2.5-5.2,2.5-6.4c0-1.1-0.3-4.2-3.3-6
		c-1.9-1.2-3.5-1.6-8.5-1.8l-18.8,0.1c-1.1,13.5-2.1,27.1-2.6,40.6c-0.3,5.8-0.4,11.5-0.5,17.3H150c0.9-7.4,1.5-14.8,2-22.3
		c0.4-5.7,0.6-11.5,0.9-17.3c0.4-6.2,0.7-12.2,0.9-18.3c0.1-3.7,0.1-7.3,0.1-11L199.6,984L199.6,984z"/>
              <path class="st693" d="M249.3,983.9c-1,11.7-2,23.5-2.7,35.3c-0.7,11.2-1.3,22.6-1.9,33.8h-19.3c1.3-11.9,2.4-23.7,3.2-35.6
		c0.6-11.2,0.9-22.3,1.3-33.6L249.3,983.9z"/>
              <path class="st693" d="M328.4,996.8c-9.3-1.6-11.9-2.1-21.3-2.6c-10.9,0.3-19.9,1-26.7,8.1c-2.7,2.9-7.3,9-7.3,18.1
		c0,9.5,5.6,17.1,17.2,20.3c2.9,0.8,5.6,1.2,11.8,1.6c10.9,0,13.6-0.4,23.8-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.5,1.3
		c-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.5-0.6c-6.6-1.2-12-2.1-17.7-5.2c-9.9-5.4-13.3-12.8-14.4-15.9c-1.4-3.9-1.7-8.3-1.9-9.5
		c0-8.5,0.6-10,1.9-14.5c1.6-4.2,2.7-6.4,3.9-8.2c4.5-7.1,12.6-13.2,22.2-15.9c4.4-1.2,8-1.6,12.6-2.1c10.4-0.4,14.4-0.7,32,1.2
		L328.4,996.8z"/>
              <path class="st693" d="M402,983.7l-0.5,12.4c-7.8-0.4-15.5-0.7-23.4-0.7c-7.6,0-15.3,0.2-23,0.4l-0.7,15.7l40.5-0.3l-0.7,12.5
		c-7.2-0.2-14.4-0.5-21.5-0.5c-6.4,0-12.6,0.1-18.9,0.3l-1,17.6c8.8,0.1,17.7,0.3,26.4,0.1c6.8-0.2,13.4-0.5,20.2-0.9v12.5h-66.4
		c0.5-3.9,1-7.6,1.4-11.5c0.5-5.7,0.7-11.5,1-17.1c0.5-7.8,1-15.7,1.3-23.5c0.3-5.7,0.3-11.4,0.4-17.1L402,983.7L402,983.7z"/>
              <g>
		<path class="st404" d="M507.8,1008.4l-14.1-43.8h18.4l6.4,22.3l9.1-22.3h18.4c-1.6,3.1-3.3,6.3-4.8,9.4
			c-2.9,5.9-5.5,11.9-8.2,17.8c-2.4,5.4-4.8,10.7-7.3,16.1l10.7,33.8c1.2-3,2.4-6,3.7-8.9c1.6-3.5,3.3-6.9,4.8-10.5
			c3.3-6.9,6.4-13.9,9.7-20.8c3-6.3,5.9-12.7,8.6-18.9c2.5-6,4.8-12,7.2-18h19.9c-4.1,8.1-8,16.2-11.8,24.4
			c-3.4,7.3-6.7,14.8-10.1,22.1c-4,8.9-8.4,17.6-12.4,26.5c-2.7,6.1-5.4,12.4-8,18.7h-25c-1.2-4.2-2.2-8.2-3.4-12.3
			c-1.6-4.8-3.1-9.5-4.7-14.2l-3.5,8.6c-1.3,2.9-2.7,5.6-3.9,8.5c-1.4,3.1-2.6,6.3-3.9,9.4h-24.4c-1.7-6.5-3.5-12.9-5.5-19.3
			c-2.4-7.3-5-14.5-7.3-21.8c-3.8-11.4-7.3-23-11.2-34.4c-1.8-5.4-3.7-10.7-5.5-16.2l20.5,0.1c1.3,5.5,2.5,11,4.1,16.5
			c1.8,6.3,3.8,12.5,5.9,18.8c0.9,2.7,1.7,5.5,2.6,8.2c3.4,10.7,6.8,21.6,10.2,32.4L507.8,1008.4z"/>
                <path class="st693" d="M635,986.5c2.1,5.2,4.4,10.3,6.8,15.5c3.3,6.8,6.7,13.5,10,20.3c5.4,11.3,10.8,22.6,16.3,33.9h-20.9
			c-2.9-8.7-3.9-12.1-11.5-26.5h-33.8c-3.4,5-6.9,9.8-10.2,14.9c-2.4,3.8-4.7,7.7-6.8,11.5h-19.8l46.3-69.7H635z M607.8,1018.9h23.7
			l-10-21.6L607.8,1018.9z"/>
                <path class="st693" d="M734.8,986.7c0,2.2,0,4.4-0.1,6.5c-0.1,2-0.4,3.9-0.6,5.9c-4.8-0.2-9.5-0.5-14.2-0.5c-3.2-0.1-6.3,0-9.5,0
			c-0.8,8.7-1.5,17.3-1.9,26c-0.6,10.6-1,21.3-1.3,32l-19.4-0.1c0.9-9.8,1.9-19.8,2.5-29.7c0.6-9.3,1-18.8,1.3-28.1
			c-5.2-0.1-10.3-0.1-15.4,0.1c-2.8,0.1-5.4,0.3-8.2,0.4l0.8-12.4L734.8,986.7z"/>
                <path class="st693" d="M806.7,999.6c-9.3-1.7-12-2.2-21.4-2.6c-11,0.3-20,1-26.9,8.2c-2.8,2.9-7.3,9-7.3,18.2
			c0,9.5,5.7,17.2,17.3,20.5c2.9,0.8,5.7,1.2,11.8,1.7c11,0,13.7-0.4,24-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.6,1.3
			c-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.6-0.6c-6.7-1.2-12.1-2.2-17.8-5.3c-10-5.4-13.4-12.9-14.5-16c-1.4-4-1.8-8.4-1.9-9.5
			c0-8.6,0.6-10,1.9-14.6c1.6-4.2,2.8-6.5,3.9-8.3c4.5-7.2,12.7-13.2,22.3-16c4.4-1.2,8.1-1.6,12.7-2.1c10.5-0.4,14.5-0.7,32.3,1.2
			L806.7,999.6z"/>
                <path class="st693" d="M834.5,986.5l-2.3,27.9h47.5c0.5-5.5,0.9-10.9,1.1-16.4c0.1-3.9,0.3-7.7,0.4-11.5l19.7,0.1
			c-1.1,12.5-2.3,25.2-3,37.8c-0.6,10.5-0.9,21.2-1.1,31.8h-19.5c0.6-7.3,1.4-14.4,1.6-21.7c0.1-2.7,0.1-5.5,0.3-8.3l-47.4,0.1
			c-0.4,7-0.9,13.9-1,21c-0.1,2.9-0.1,5.9-0.3,8.9h-19.8c1.3-13.2,2.4-26.5,3-39.7c0.5-10,0.8-20.1,0.9-30H834.5z"/>
                <path class="st693" d="M978,986.5l-0.5,12.4c-7.8-0.4-15.6-0.7-23.6-0.7c-7.7,0-15.4,0.2-23.1,0.4l-0.8,15.8l40.7-0.3l-0.8,12.6
			c-7.2-0.2-14.5-0.5-21.7-0.5c-6.4,0-12.7,0.1-19,0.3l-1,17.7c8.8,0.1,17.8,0.3,26.6,0.1c6.8-0.2,13.5-0.5,20.3-0.9v12.6h-66.8
			c0.5-3.9,1-7.7,1.4-11.5c0.5-5.8,0.8-11.5,1-17.2c0.5-7.9,1-15.8,1.3-23.7c0.3-5.8,0.3-11.4,0.4-17.2H978z"/>
                <path class="st693" d="M1031.6,986.8c5.5,0.4,10.7,0.9,15.1,3.7c2.8,1.7,7.7,6.2,7.7,13.8c0,1-0.1,3.2-1,5.7
			c-0.9,2.7-3.7,8.9-11.7,12.8c-2.9,1.4-6.8,2.6-10.1,3.5l18.8,29.9H1029c-2-4.2-4-8.3-6.4-12.3c-2.3-4.1-4.8-8.2-7.2-12.1
			c-3-4.9-5.9-9.7-8.8-14.5c2.9,0.2,5.8,0.4,8.7,0.4c2.3,0,12.2-0.1,17.1-5.6c2.3-2.6,2.5-5.3,2.5-6.5c0-1.1-0.3-4.2-3.3-6.1
			c-1.9-1.2-3.5-1.6-8.6-1.8l-18.9,0.1c-1.1,13.6-2.1,27.2-2.6,40.9c-0.3,5.9-0.4,11.6-0.5,17.4h-19.4c0.9-7.5,1.5-14.9,2-22.5
			c0.4-5.8,0.6-11.6,0.9-17.4c0.4-6.2,0.8-12.2,0.9-18.4c0.1-3.7,0.1-7.4,0.1-11H1031.6z"/>
	</g>
</g>
            <g>
	<g id="Device_00000061472743477043613180000013547389155823413408_">
		<g id="Monitor_00000063630725263384872250000009783412620832976297_">

				<linearGradient id="XMLID_00000037689484820180144000000012776445398189452703_" gradientUnits="userSpaceOnUse"
                        x1="262.6432" y1="419" x2="757.4606" y2="419">
				<stop offset="0" style="stop-color:#6B59A6"/>
          <stop offset="0.5631" style="stop-color:#7D96AD"/>
          <stop offset="1" style="stop-color:#8CC9B2"/>
			</linearGradient>

      <path id="XMLID_00000078733643085833727460000015115043492975715506_"
            style="fill:url(#XMLID_00000037689484820180144000000012776445398189452703_);" d="
				M270.6,769.2c4.4,2.5,11.8,2.4,16.5-0.3C345.8,735,690.3,536.1,749,502.2c4.7-2.7,8.5-9.3,8.5-14.7V83.3c0-5.4-3.6-11.9-8-14.4
				c-4.4-2.5-11.8-2.4-16.5,0.3L271.2,335.8c-4.7,2.7-8.5,9.3-8.5,14.7l0,404.2C262.6,760.2,266.2,766.6,270.6,769.2z"/>

      <linearGradient id="XMLID_00000144306661987948916920000010909138852342970296_" gradientUnits="userSpaceOnUse"
                      x1="278.607" y1="423.5967" x2="757.4635" y2="423.5967">
				<stop offset="0" style="stop-color:#6B59A6"/>
        <stop offset="0.5631" style="stop-color:#7D96AD"/>
        <stop offset="1" style="stop-color:#8CC9B2"/>
			</linearGradient>

      <path id="XMLID_00000057137653957608487450000004108798636493404598_"
            style="fill:url(#XMLID_00000144306661987948916920000010909138852342970296_);" d="
				M287.1,768.9L749,502.2c4.7-2.7,8.5-9.3,8.5-14.7V83.2c0-5.4-3.8-7.6-8.5-4.9L287.1,345c-4.7,2.7-8.5,9.3-8.5,14.7l0,404.2
				C278.6,769.4,282.4,771.6,287.1,768.9z"/>

      <linearGradient id="XMLID_00000018233157377277033250000016368279973027255681_" gradientUnits="userSpaceOnUse"
                      x1="294.5649" y1="408.7614" x2="741.5064" y2="408.7614">
				<stop offset="0" style="stop-color:#165A46"/>
        <stop offset="0.5359" style="stop-color:#53947E"/>
        <stop offset="1" style="stop-color:#8CC9B2"/>
			</linearGradient>

      <path id="XMLID_00000036958969269717369510000009648725533562935976_"
            style="fill:url(#XMLID_00000018233157377277033250000016368279973027255681_);" d="
				M294.6,710.6l0-345.5c0-3.3,2.3-7.2,5.1-8.8L736.4,104c2.8-1.6,5.1-0.3,5.1,2.9l0,345.6c0,3.3-2.3,7.2-5.1,8.8L299.7,713.5
				C296.9,715.1,294.6,713.8,294.6,710.6z"/>
      <path id="XMLID_00000080907154437711255030000013484228551001794239_" class="st697" d="M294.6,710.6l0-345.5
				c0-3.3,2.3-7.2,5.1-8.8L736.4,104c2.8-1.6,5.1-0.3,5.1,2.9l0,345.6c0,3.3-2.3,7.2-5.1,8.8L299.7,713.5
				C296.9,715.1,294.6,713.8,294.6,710.6z"/>

      <linearGradient id="SVGID_00000162329573743280636550000018178889841458502529_" gradientUnits="userSpaceOnUse"
                      x1="511.7806" y1="607.9062" x2="529.679" y2="607.9062">
				<stop offset="0" style="stop-color:#165A46"/>
        <stop offset="0.5359" style="stop-color:#53947E"/>
        <stop offset="1" style="stop-color:#8CC9B2"/>
			</linearGradient>
      <path style="fill:url(#SVGID_00000162329573743280636550000018178889841458502529_);" d="M517.2,619.2c-0.9,0-1.8-0.2-2.6-0.7
				c-1.8-1-2.8-3.2-2.8-6c0-5.5,3.7-11.9,8.5-14.7l0,0c2.4-1.4,4.8-1.6,6.6-0.6c1.8,1.1,2.8,3.2,2.8,6c0,5.5-3.7,11.9-8.5,14.7
				C519.8,618.8,518.4,619.2,517.2,619.2z M524.3,598.6c-0.9,0-2,0.3-3.1,1l0,0c-4.1,2.4-7.5,8.2-7.5,13c0,2.1,0.7,3.6,1.9,4.3
				c1.2,0.7,2.9,0.5,4.7-0.6c4.1-2.4,7.5-8.2,7.5-13c0-2.1-0.7-3.6-1.9-4.3C525.4,598.7,524.9,598.6,524.3,598.6z"/>
		</g>
	</g>
              <g id="Window_00000137122717356888757400000014323077822793007780_">
		<g>
			<g>
				<path class="st697"
              d="M817.4,169.1L367.6,428.4l0,331.5c0,4.4,4.8,7.2,8.6,5l8-4.6L809,515.4c4.6-2.7,8.4-9.2,8.4-14.5V169.1z"
        />
        <path class="st662" d="M815.4,172.4v328.4c0,4.6-3.4,10.5-7.4,12.8L383.2,758.6l-8,4.6c-0.6,0.3-1.2,0.5-1.9,0.5
					c-1,0-1.9-0.4-2.7-1.1c-0.7-0.7-1.2-1.7-1.2-2.7l0-330.4L815.4,172.4 M817.4,169.1L367.6,428.4l0,331.5c0,3.3,2.8,5.8,5.8,5.8
					c1,0,1.9-0.2,2.8-0.8l8-4.6L809,515.4c4.6-2.7,8.4-9.2,8.4-14.5V169.1L817.4,169.1z"/>
			</g>
      <polygon class="st699" points="806.7,162.9 356.9,422.3 367.6,428.4 817.4,169.1 			"/>
      <path class="st664" d="M370.6,765c0,0-3-1.5-3-5.1l0-322c0-2.6,0-9.5,0-9.5l-10.7-6.2l0,329.7c0,0.4,0,0.8,0.1,1.2
				c0.4,2.7,2,5.1,4.4,6.5l8.8,5.1L370.6,765L370.6,765z"/>
		</g>
                <g>
			<g>

					<linearGradient id="SVGID_00000161626713202169307930000008006692510298651579_" gradientUnits="userSpaceOnUse"
                          x1="356.875" y1="282.9086" x2="817.3567" y2="282.9086">
					<stop offset="0" style="stop-color:#6B59A6"/>
            <stop offset="1" style="stop-color:#3E3F6F"/>
				</linearGradient>
        <path style="fill:url(#SVGID_00000161626713202169307930000008006692510298651579_);" d="M356.9,422.4V400
					c0-2.7,1.9-5.9,4.2-7.3l441.5-254.5c2.3-1.3,6-1.4,8.4,0l2.3,1.3c2.3,1.3,4.2,4.6,4.2,7.2l0,22.4L367.6,428.6L356.9,422.4z"/>
        <path class="st701"
              d="M368.8,402.1c-0.8,1.3-1.2,2.8-1.2,4.1v22.4l-10.7-6.2V400c0-1.3,0.5-2.8,1.2-4.1L368.8,402.1z"/>
			</g>
                  <path class="st702" d="M367.6,406.2c0-2.7,1.9-5.9,4.2-7.3l441.4-254.5c2.3-1.3,4.2-0.3,4.2,2.4l0,22.4L367.6,428.6L367.6,406.2z
				"/>
                  <g>
				<path class="st406" d="M797.7,168.2c0,2.5,1.8,3.5,3.9,2.3c2.2-1.3,3.9-4.3,3.9-6.8c0-2.5-1.8-3.5-3.9-2.3
					C799.5,162.7,797.7,165.7,797.7,168.2z"/>
                    <path class="st406" d="M782,177.3c0,2.5,1.8,3.5,3.9,2.3c2.2-1.3,3.9-4.3,3.9-6.8c0-2.5-1.8-3.5-3.9-2.3
					C783.8,171.7,782,174.8,782,177.3z"/>
                    <path class="st406" d="M766.3,186.3c0,2.5,1.8,3.5,3.9,2.3c2.2-1.3,3.9-4.3,3.9-6.8c0-2.5-1.8-3.5-3.9-2.3
					C768.1,180.8,766.3,183.8,766.3,186.3z"/>
			</g>
		</g>
                <g>
			<path class="st703" d="M367.6,428.6l0,331.4c0,4.4,4.8,7.2,8.6,5l8-4.6l98.3-56.7V362.3L367.6,428.6L367.6,428.6z"/>
                  <polygon class="st703" points="490.3,367.9 490.3,689.7 807.9,506.4 807.9,184.5 			"/>
                  <g>
				<path class="st704" d="M456.2,401.2l-73.3,42.4c-1.4,0.8-2.5,2.7-2.5,4.3l0,7.6c0,1.6,1.1,2.2,2.5,1.4l73.3-42.4
					c1.4-0.8,2.5-2.7,2.5-4.3l0-7.6C458.6,401.1,457.5,400.4,456.2,401.2z"/>
                    <path class="st705" d="M456.2,401.2l-73.3,42.4c-1.4,0.8-2.5,2.7-2.5,4.3l0,7.6c0,1.6,1.1,2.2,2.5,1.4l73.3-42.4
					c1.4-0.8,2.5-2.7,2.5-4.3l0-7.6C458.6,401.1,457.5,400.4,456.2,401.2z"/>
                    <path class="st706" d="M472.5,404.2l-2.2-2.1c0.4-1.1,0.7-2.3,0.7-3.5c0-1.8-0.6-3.1-1.6-3.7c-0.8-0.5-1.7-0.4-2.6,0.1
					c-1.9,1.1-3.4,4.2-3.4,7c0,1.8,0.6,3.1,1.6,3.7c0.4,0.2,0.8,0.3,1.2,0.3c0.5,0,1-0.1,1.5-0.4c0.7-0.4,1.4-1.1,1.9-2l1.8,1.7
					c0.2,0.2,0.4,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.3C472.8,405.1,472.8,404.6,472.5,404.2z M466.8,404.2c-0.4,0.2-0.7,0.3-0.9,0.1
					c-0.4-0.2-0.8-0.9-0.8-2.2c0-2.2,1.2-4.8,2.5-5.5c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0,0.3,0.1c0.4,0.2,0.8,0.9,0.8,2.2
					C469.3,400.9,468.2,403.4,466.8,404.2z"/>
			</g>
                  <g>
				<g>
					<g>
						<g>
							<path class="st706" d="M382.2,479.3l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9
								c0.1-0.1,0.2,0,0.2,0.1v4.5C382.4,479.1,382.3,479.2,382.2,479.3z"/>
						</g>
            <g>
							<path class="st706" d="M384.7,477.8l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9
								c0.1-0.1,0.2,0,0.2,0.1v4.5C384.8,477.6,384.8,477.8,384.7,477.8z"/>
						</g>
            <g>
							<path class="st706" d="M387.1,476.4l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9
								c0.1-0.1,0.2,0,0.2,0.1v4.5C387.3,476.2,387.2,476.4,387.1,476.4z"/>
						</g>
            <g>
							<path class="st706" d="M382.2,485l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9
								c0.1-0.1,0.2,0,0.2,0.1v4.5C382.4,484.8,382.3,484.9,382.2,485z"/>
						</g>
            <g>
							<path class="st706" d="M384.7,483.6l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9
								c0.1-0.1,0.2,0,0.2,0.1v4.5C384.8,483.4,384.8,483.5,384.7,483.6z"/>
						</g>
            <g>
							<path class="st706" d="M387.1,482.2l-1.6,0.9c-0.1,0.1-0.2,0-0.2-0.1v-4.5c0-0.1,0.1-0.3,0.2-0.3l1.6-0.9
								c0.1-0.1,0.2,0,0.2,0.1v4.5C387.3,481.9,387.2,482.1,387.1,482.2z"/>
						</g>
					</g>
          <g>
						<g>
							<path class="st706" d="M382.5,500.2l-2-1.2c-0.1,0-0.1-0.2,0-0.4l2-3.6c0.1-0.2,0.2-0.1,0.2,0v4.8
								C382.7,500,382.6,500.2,382.5,500.2z"/>
						</g>
            <g>
							<path class="st706"
                    d="M381.6,497.4l2.7-1.5v1.3l-2.7,1.5c-0.2,0.1-0.4,0-0.4-0.4C381.2,498,381.4,497.6,381.6,497.4z"/>
              <polygon class="st706" points="384.8,495.6 385.7,495.1 385.7,496.4 384.8,496.9 							"/>
              <path class="st706" d="M388.1,494.3v4.7c0,0.4-0.2,0.7-0.4,0.9c-0.2,0.1-0.4,0-0.4-0.4v-4l-1.1,0.7v-1.3l1.5-0.9
								C387.9,493.8,388.1,494,388.1,494.3z"/>
						</g>
					</g>
          <g>
						<g>
							<path class="st706" d="M383.2,510.6c-1.9,1.3-3.2,4.9-2.8,7.5c0.3,2.4,1.8,2.3,1.9,3.5c0,0.1,0.1,0.2,0.2,0.1l1.8-1
								c0.1-0.1,0.2-0.2,0.2-0.3c0.2-1.5,2-3.3,2-6.9C386.6,510.7,385.1,509.3,383.2,510.6z"/>
						</g>
            <path class="st706" d="M384.3,523.6l-1.7,1c-0.1,0.1-0.2,0-0.2-0.2v-1.6c0-0.2,0.1-0.3,0.2-0.4l1.7-1c0.1-0.1,0.2,0,0.2,0.2
							v1.6C384.5,523.3,384.4,523.5,384.3,523.6z"/>
					</g>
          <path class="st706" d="M383.7,473c-1.6,1.3-2.9,4.1-3.2,6.7c-0.2,1.5,0,2.8,0.5,3.6l-0.6,3c0,0.3,0.1,0.4,0.2,0.2l1.8-1.9
						c0.7,0.2,1.6,0,2.5-0.7c1.6-1.3,2.9-4.1,3.2-6.7C388.5,473,386.3,470.9,383.7,473z M384.3,483c-1.6,0.9-2.9-0.3-2.9-2.8
						c0-2.5,1.3-5.3,2.9-6.2c1.6-0.9,2.9,0.3,2.9,2.8C387.2,479.3,385.9,482,384.3,483z"/>
          <path class="st706" d="M383.7,531.7c-1.6,1.3-2.9,4.1-3.2,6.7c-0.2,1.5,0,2.8,0.5,3.6l-0.6,3c0,0.3,0.1,0.4,0.2,0.2l1.8-1.9
						c0.7,0.2,1.6,0,2.5-0.7c1.6-1.3,2.9-4.1,3.2-6.7C388.5,531.7,386.3,529.5,383.7,531.7z M384.3,541.6c-1.6,0.9-2.9-0.3-2.9-2.8
						c0-2.5,1.3-5.3,2.9-6.2s2.9,0.3,2.9,2.8C387.2,537.9,385.9,540.7,384.3,541.6z"/>
          <g>
						<path class="st706" d="M386.1,553.2c0,1.3-0.7,2.8-1.5,3.3c-0.9,0.5-1.5-0.2-1.5-1.5s0.7-2.8,1.5-3.3
							C385.5,551.2,386.1,551.8,386.1,553.2z"/>
            <path class="st706" d="M388.8,553.6c0,0.9-0.5,1.8-1,2.2c-0.6,0.3-1-0.1-1-1c0-0.9,0.5-1.8,1-2.2
							C388.3,552.3,388.8,552.8,388.8,553.6z"/>
            <path class="st706" d="M386.4,562.5l-3.6,2.1V560c0-1,0.6-2.1,1.3-2.5l1-0.6c0.7-0.4,1.3,0,1.3,1V562.5z"/>
            <path class="st706" d="M387.9,556.3l-1,0.6v5.3l1.9-1.1V557C388.8,556.4,388.4,556.1,387.9,556.3z"/>
            <path class="st706" d="M380.4,558.5c0,0.9,0.5,1.3,1,1c0.6-0.3,1-1.3,1-2.2c0-0.9-0.5-1.3-1-1
							C380.9,556.6,380.4,557.6,380.4,558.5z"/>
            <path class="st706" d="M381.3,560.2l1-0.6v5.3l-1.9,1.1v-4.1C380.4,561.2,380.8,560.5,381.3,560.2z"/>
					</g>
				</g>
                    <g>
					<path class="st662" d="M398.2,468.8l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C396.1,471,397.1,469.5,398.2,468.8z"/>
                      <path class="st662" d="M398.2,489l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C396.1,491.3,397.1,489.7,398.2,489z"/>
                      <path class="st662" d="M398.2,509.2l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C396.1,511.5,397.1,509.9,398.2,509.2z"/>
                      <path class="st662" d="M398.2,529.4l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5L398.2,534
						c-1.2,0.7-2.1,0.2-2.1-1.1C396.1,531.7,397.1,530.1,398.2,529.4z"/>
                      <path class="st662" d="M398.2,549.6l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C396.1,551.9,397.1,550.3,398.2,549.6z"/>
                      <path class="st706" d="M406.1,566.1l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1S404.9,566.8,406.1,566.1z"/>
                      <path class="st662" d="M406.1,579.8L449,555c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C404,582,404.9,580.5,406.1,579.8z"/>
                      <path class="st662" d="M406.1,593.4l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5L406.1,598
						c-1.2,0.7-2.1,0.2-2.1-1.1C404,595.7,404.9,594.1,406.1,593.4z"/>
                      <path class="st662" d="M414.4,602.1l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1S413.3,602.8,414.4,602.1z"/>
                      <g>
						<path class="st706" d="M404.4,613.9l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,614.1,404.2,614.1,404.4,613.9z"/>
					</g>
                      <path class="st662" d="M414.4,615.7l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1S413.3,616.4,414.4,615.7z"/>
                      <g>
						<path class="st706" d="M404.4,627.5l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,627.7,404.2,627.7,404.4,627.5z"/>
					</g>
                      <path class="st662" d="M414.4,629.3l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C412.3,631.5,413.3,630,414.4,629.3z"/>
                      <g>
						<path class="st706" d="M404.4,641.1l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,641.3,404.2,641.3,404.4,641.1z"/>
					</g>
                      <path class="st662" d="M414.4,642.9l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C412.3,645.1,413.3,643.6,414.4,642.9z"/>
                      <g>
						<path class="st706" d="M404.4,654.7l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,654.9,404.2,654.9,404.4,654.7z"/>
					</g>
                      <path class="st662" d="M414.4,656.5l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5L414.4,661
						c-1.2,0.7-2.1,0.2-2.1-1.1C412.3,658.7,413.3,657.2,414.4,656.5z"/>
                      <g>
						<path class="st706" d="M404.4,668.3l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,668.5,404.2,668.5,404.4,668.3z"/>
					</g>
                      <path class="st662" d="M414.4,670.1l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C412.3,672.3,413.3,670.8,414.4,670.1z"/>
                      <g>
						<path class="st706" d="M404.4,681.9l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,682.1,404.2,682.1,404.4,681.9z"/>
					</g>
                      <path class="st662" d="M414.4,683.7l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C412.3,685.9,413.3,684.4,414.4,683.7z"/>
                      <g>
						<path class="st706" d="M404.4,695.5l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,695.7,404.2,695.7,404.4,695.5z"/>
					</g>
                      <path class="st662" d="M414.4,697.3l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C412.3,699.5,413.3,698,414.4,697.3z"/>
                      <g>
						<path class="st706" d="M404.4,709.1l3.5-6.2c0.1-0.2,0.1-0.5,0-0.6l-3.5-2.1c-0.2-0.1-0.4,0.2-0.4,0.6v8.3
							C404,709.3,404.2,709.3,404.4,709.1z"/>
					</g>
				</g>
			</g>
                  <g>
				<g>
					<path class="st697" d="M500.3,412l141.1-81.4c1.2-0.7,2.1-2.3,2.1-3.6v-36c0-1.3-0.9-1.9-2.1-1.2l-141.1,81.4
						c-1.2,0.7-2.1,2.3-2.1,3.6v36C498.2,412.2,499.1,412.7,500.3,412z"/>
          <g id="XMLID_00000072968645905946564020000007817186222589034166_">
						<g id="XMLID_00000167373217720417247470000010158439763454396568_">
							<path class="st706" d="M512.6,386.7C512.6,386.6,512.6,386.6,512.6,386.7l0.9-3.9l-1.3,0.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.1
								v-0.7c0,0,0-0.1,0-0.1c0,0,0.1-0.1,0.1-0.1l2-1.2c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1v0.6c0,0.1,0,0.2-0.1,0.4l-0.9,3.9
								c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.1l-0.6,0.3C512.7,386.8,512.6,386.8,512.6,386.7C512.6,386.7,512.6,386.7,512.6,386.7z"/>
              <path class="st706" d="M516,380.2c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4
								c0.1,0.2,0.1,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.1,0.5-0.2,0.7
								c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.3,0.3-0.6,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.3-0.1-0.4-0.2
								c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0.1-0.7
								c0-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.2-0.4,0.4-0.6C515.6,380.4,515.8,380.3,516,380.2z M516.5,382.8c0-0.4,0-0.8,0-1.1
								c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.2,0.2
								c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.4,0,0.7,0,1.1c0,0.1,0,0.2,0,0.3
								c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.2
								c0-0.1,0.1-0.2,0.1-0.3C516.4,383,516.5,382.9,516.5,382.8z"/>
              <path class="st706" d="M519,379.4c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3
								c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3
								c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3
								c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2
								C518.9,379.2,519,379.3,519,379.4z M520,378c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0.4-0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0.1
								c0,0,0,0,0,0c0,0,0,0,0,0l-2.1,5.5c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1l-0.4,0.2c0,0-0.1,0-0.1,0c0,0,0,0,0-0.1
								c0,0,0,0,0,0c0,0,0,0,0,0L520,378z M518.1,380.4c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3
								c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.3
								C518.1,380.1,518.1,380.2,518.1,380.4z M521,380.6c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4
								c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1
								c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4
								c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1
								c0.1,0.1,0.1,0.1,0.1,0.2C520.9,380.3,521,380.5,521,380.6z M520.1,381.5c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0
								c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.2,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2
								c0,0.1,0,0.2,0,0.3C520.1,381.3,520.1,381.4,520.1,381.5z"/>
						</g>
            <g id="XMLID_00000044868265778579349310000012006288693181377448_">
							<path id="XMLID_00000120531237328809010610000015923951295657917068_" class="st706" d="M512.6,375.6l-1.4-2.2
								c-1.6,2.6-2.7,5.8-3.3,9l2.3-0.2C510.5,379.9,511.4,377.5,512.6,375.6z"/>
              <path id="XMLID_00000016074778353802237890000003606302221663189392_" class="st706" d="M516.6,371.3v-3.7
								c-2,1.2-3.9,3.3-5.4,5.8l1.4,2.2C513.7,373.7,515.1,372.1,516.6,371.3z"/>
              <path id="XMLID_00000151503114317933288900000006835987728718290072_" class="st706" d="M509.7,385.7c0-1.1,0.1-2.3,0.3-3.4
								l-2.3,0.2c-0.3,1.5-0.5,3.1-0.5,4.6c0,1.5,0.2,2.9,0.5,4.1l2.3-2.5C509.9,387.8,509.7,386.8,509.7,385.7z"/>
              <path id="XMLID_00000002384337300152688120000011131918148307720886_" class="st704" d="M525.3,372.3
								c-0.6-2.5-1.8-4.3-3.3-5.2c-1.5-0.8-3.4-0.8-5.4,0.4v3.7c1.5-0.9,2.9-0.9,4-0.3c1.1,0.6,2,1.9,2.5,3.8c0.2,0.9,0.3,1.9,0.3,3
								c0,1.1-0.1,2.3-0.3,3.4c-0.4,2.4-1.3,4.7-2.5,6.7c-1.1,1.9-2.5,3.5-4,4.3c-1.5,0.9-2.9,0.9-4,0.3c-1.1-0.6-2-1.9-2.5-3.8
								l-2.3,2.5c0.6,2.5,1.8,4.3,3.3,5.2c1.5,0.8,3.4,0.8,5.4-0.4c2-1.2,3.9-3.3,5.4-5.8c1.6-2.6,2.7-5.8,3.3-9
								c0.3-1.5,0.5-3.1,0.5-4.6S525.6,373.5,525.3,372.3z"/>
						</g>
					</g>
          <path class="st706" d="M539.5,362.2l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-42.9,24.8
						c-1.2,0.7-2.1,0.2-2.1-1.1C537.4,364.4,538.4,362.8,539.5,362.2z"/>
          <path class="st662" d="M539.5,371.3l74.3-42.9c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-74.3,42.9
						c-1.2,0.7-2.1,0.2-2.1-1.1C537.4,373.5,538.4,372,539.5,371.3z"/>
				</g>
                    <g>
					<path class="st697" d="M653.4,323.6l141.1-81.4c1.2-0.7,2.1-2.3,2.1-3.6v-36c0-1.3-0.9-1.9-2.1-1.2l-141.1,81.4
						c-1.2,0.7-2.1,2.3-2.1,3.6v36C651.3,323.8,652.2,324.3,653.4,323.6z"/>
                      <g id="XMLID_00000145050468498538114450000015982460216364749464_">
						<g id="XMLID_00000008138133886428888500000009542734875860885172_">
							<path class="st706" d="M666.4,295c0-0.3,0-0.5,0.1-0.7c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.2,0.3-0.4,0.4-0.6
								c0.2-0.2,0.3-0.3,0.5-0.4c0.2-0.1,0.3-0.1,0.5-0.2c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.6
								c0,0.1,0,0.3,0,0.4c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.1,0.3l-0.8,2.2c0,0,0,0.1,0,0.1
								c0,0,0,0.1-0.1,0.1l-0.7,0.4c0,0,0,0-0.1,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0l0.5-1.5c-0.1,0.1-0.3,0.1-0.4,0.1
								c-0.1,0-0.2-0.1-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.4C666.4,295.4,666.4,295.2,666.4,295z M668.1,294c0-0.1,0-0.2,0-0.2
								c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.1,0.1-0.1,0.2
								c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2-0.1
								c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.2C668.1,294.2,668.1,294.1,668.1,294z"/>
              <path class="st706" d="M670.5,290.9c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4
								c0,0.2,0.1,0.4,0.1,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.1,0.5-0.2,0.7
								c-0.1,0.2-0.2,0.4-0.4,0.6c-0.2,0.2-0.3,0.3-0.6,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2,0-0.3-0.1-0.4-0.2
								c-0.1-0.1-0.2-0.3-0.2-0.4c0-0.2-0.1-0.4-0.1-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0.1-0.7
								c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.2,0.2-0.4,0.4-0.6C670.1,291.2,670.3,291.1,670.5,290.9z M670.9,293.6c0-0.4,0-0.8,0-1.1
								c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1-0.1-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.1,0-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.2
								c-0.1,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.4,0,0.7,0,1.1c0,0.1,0,0.2,0,0.3
								c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0.1,0.1,0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.2-0.1,0.2-0.2c0.1-0.1,0.1-0.2,0.1-0.2
								c0-0.1,0.1-0.2,0.1-0.3C670.9,293.8,670.9,293.7,670.9,293.6z"/>
              <path class="st706" d="M673.4,290.2c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3
								c-0.1,0.1-0.2,0.2-0.3,0.2s-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3
								c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3
								c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2
								C673.4,290,673.4,290.1,673.4,290.2z M674.5,288.8c0-0.1,0-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0.4-0.2c0,0,0.1,0,0.1,0
								c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0l-2.1,5.5c0,0.1,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1l-0.4,0.2c0,0-0.1,0-0.1,0
								c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0L674.5,288.8z M672.6,291.2c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.1-0.2
								c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0,0.2,0,0.3
								C672.6,290.9,672.6,291,672.6,291.2z M675.4,291.4c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4
								c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.2-0.1
								c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0.1-0.4
								c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0.1
								c0.1,0.1,0.1,0.1,0.1,0.2C675.4,291.1,675.4,291.2,675.4,291.4z M674.6,292.3c0,0.1,0,0.2,0,0.2c0,0,0.1,0,0.1,0
								c0.1,0,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.3,0-0.4c0-0.1,0-0.2,0-0.2c0,0-0.1,0-0.1,0c-0.1,0-0.1,0.1-0.1,0.2
								c0,0.1,0,0.2,0,0.3C674.6,292,674.6,292.2,674.6,292.3z"/>
						</g>
                        <g id="XMLID_00000145017323626838607870000017359005799494442375_">
							<path id="XMLID_00000075121219289113956370000010561945007297178294_" class="st706" d="M670.9,282.1v-3.7
								c-2,1.2-3.9,3.3-5.4,5.8l1.4,2.2C668,284.5,669.4,283,670.9,282.1z"/>
                          <path id="XMLID_00000143586822855497195390000013960178667247713444_" class="st704" d="M679.7,283.2
								c-0.6-2.5-1.8-4.3-3.3-5.2c-1.5-0.8-3.4-0.8-5.4,0.4v3.7c1.5-0.9,2.9-0.9,4-0.3c1.1,0.6,2,1.9,2.5,3.8c0.2,0.9,0.3,1.9,0.3,3
								c0,1.1-0.1,2.3-0.3,3.4c-0.4,2.4-1.3,4.7-2.5,6.7c-1.1,1.9-2.5,3.5-4,4.3c-1.5,0.9-2.9,0.9-4,0.3c-1.1-0.6-2-1.9-2.5-3.8
								c-0.2-0.9-0.3-1.9-0.3-3c0-1.1,0.1-2.3,0.3-3.4c0.4-2.4,1.3-4.7,2.5-6.7l-1.4-2.2c-1.6,2.6-2.7,5.8-3.3,9
								c-0.3,1.5-0.5,3.1-0.5,4.6s0.2,2.9,0.5,4.1c0.6,2.5,1.8,4.3,3.3,5.2c1.5,0.8,3.4,0.8,5.4-0.4c2-1.2,3.9-3.3,5.4-5.8l0,0l0,0
								c1.6-2.6,2.7-5.8,3.3-9c0.3-1.5,0.5-3.1,0.5-4.6S680,284.4,679.7,283.2z"/>
						</g>
					</g>
                      <path class="st706" d="M693.9,273l42.9-24.8c1.2-0.7,2.1-0.2,2.1,1.1s-0.9,2.8-2.1,3.5l-42.9,24.8c-1.2,0.7-2.1,0.2-2.1-1.1
						C691.8,275.2,692.7,273.7,693.9,273z"/>
                      <path class="st662" d="M693.9,282.2l74.3-42.9c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-74.3,42.9
						c-1.2,0.7-2.1,0.2-2.1-1.1C691.8,284.4,692.7,282.8,693.9,282.2z"/>
				</g>
			</g>
                  <g>
				<path class="st706" d="M514.6,421.9l30.1-17.4c1.2-0.7,2.1-0.2,2.1,1.1c0,1.3-0.9,2.8-2.1,3.5l-30.1,17.4
					c-1.2,0.7-2.1,0.2-2.1-1.1C512.6,424.1,513.5,422.6,514.6,421.9z"/>
                    <path class="st662" d="M795.5,271L795.5,271L795.5,271 M794.6,271.5l0,229.9c0,0.6-0.6,1.6-1.1,2L500.1,672.8l0-229.9
					c0-0.6,0.6-1.6,1.1-2l3.7-2.1c1.7-1,3.1-3.3,3.1-5.3v-13.3c0-0.6,0.6-1.6,1.1-2l42.1-24.3v12.4c0,2.2,1.6,3.4,3.1,3.4
					c0.6,0,1.3-0.2,1.9-0.5L794.6,271.5 M552.1,393.4L552.1,393.4L552.1,393.4 M795.4,269.1c-0.3,0-0.6,0.1-0.9,0.3L555.2,407.5
					c-0.3,0.2-0.7,0.3-0.9,0.3c-0.7,0-1.2-0.5-1.2-1.5V393c0-0.9-0.5-1.5-1.2-1.5c-0.3,0-0.6,0.1-0.9,0.3l-42.9,24.8
					c-1.2,0.7-2.1,2.3-2.1,3.6v13.3c0,1.3-0.9,3-2.1,3.6l-3.7,2.1c-1.2,0.7-2.1,2.3-2.1,3.6l0,230.9c0,0.9,0.5,1.5,1.2,1.5
					c0.3,0,0.6-0.1,0.9-0.3l294.2-169.8c1.2-0.7,2.1-2.3,2.1-3.6l0-230.9C796.5,269.7,796.1,269.1,795.4,269.1L795.4,269.1z"/>
                    <g>
					<path class="st662" d="M517.1,452.9c-0.4,0-0.7-0.1-1-0.3c-0.7-0.4-1.1-1.2-1.1-2.2v-8.8c0-1.7,1.1-3.6,2.6-4.5l23.3-13.5
						c0.9-0.5,1.7-0.5,2.4-0.1c0.7,0.4,1.1,1.2,1.1,2.2v8.8c0,1.7-1.1,3.6-2.6,4.5l-23.3,13.5C518,452.7,517.6,452.9,517.1,452.9z
						 M518.5,438.9c-0.9,0.5-1.6,1.8-1.6,2.8v8.8c0,0.3,0.1,0.5,0.1,0.5c0,0,0.2,0,0.5-0.1l23.3-13.5c0.9-0.5,1.6-1.8,1.6-2.8v-8.8
						c0-0.3-0.1-0.5-0.1-0.5c0,0-0.2,0-0.5,0.1L518.5,438.9z"/>
                      <path class="st662" d="M519.9,442.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7
						C518.5,444,519.1,442.9,519.9,442.5z"/>
                      <g>
						<path class="st706" d="M538.6,432.2l1.3,1.8c0,0.1,0.1,0,0.2-0.1l1.3-3.2c0.1-0.2,0-0.3-0.1-0.2l-2.5,1.5
							C538.6,431.9,538.6,432.1,538.6,432.2z"/>
					</g>
				</g>
                    <g>
					<g>
						<g>
							<path class="st704" d="M513.9,537.8c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S512.8,538.5,513.9,537.8z
								"/>
						</g>
            <g>
							<path class="st704"
                    d="M529.6,519.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5s-2,0.1-2-1.2S528.5,520.3,529.6,519.7z"/>
						</g>
            <g>
							<path class="st704"
                    d="M545.3,510.6c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5s-2,0.1-2-1.2C543.3,512.8,544.2,511.3,545.3,510.6z"
              />
						</g>
            <g>
							<path class="st704"
                    d="M561,505.5c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S559.9,506.2,561,505.5z"/>
						</g>
            <g>
							<path class="st704" d="M576.7,489.2c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S575.6,489.9,576.7,489.2z
								"/>
						</g>
            <g>
							<path class="st704" d="M592.4,483.4c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2
								C590.4,485.6,591.3,484.1,592.4,483.4z"/>
						</g>
            <g>
							<path class="st704" d="M608.1,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C606.1,467.5,607,465.9,608.1,465.3z"/>
						</g>
            <g>
							<path class="st704"
                    d="M623.8,460.8c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S622.7,461.4,623.8,460.8z"/>
						</g>
            <g>
							<path class="st704" d="M639.5,410.9c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C637.5,413.1,638.4,411.6,639.5,410.9z"/>
						</g>
            <g>
							<path class="st704" d="M655.2,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2
								C653.2,440.3,654.1,438.7,655.2,438.1z"/>
						</g>
            <g>
							<path class="st704" d="M670.9,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2
								C668.9,440.3,669.8,438.7,670.9,438.1z"/>
						</g>
            <g>
							<path class="st704" d="M686.6,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C684.6,440.3,685.5,438.7,686.6,438.1z"/>
						</g>
            <g>
							<path class="st704" d="M702.3,410.9c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C700.3,413.1,701.2,411.6,702.3,410.9z"/>
						</g>
            <g>
							<path class="st704"
                    d="M718,405.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S716.9,406.3,718,405.7z"/>
						</g>
            <g>
							<path class="st704" d="M733.8,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C731.8,385.9,732.7,384.4,733.8,383.7z"/>
						</g>
            <g>
							<path class="st704" d="M749.4,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C747.4,385.9,748.3,384.4,749.4,383.7z"/>
						</g>
            <g>
							<path class="st704" d="M765.1,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C763.1,385.9,764,384.4,765.1,383.7z"/>
						</g>
            <g>
							<path class="st704" d="M780.8,374.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C778.8,376.9,779.7,375.3,780.8,374.6z"/>
						</g>
					</g>
                      <g>
						<path class="st704" d="M513.8,540.7c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l15.9-18.2c0,0,0.1-0.1,0.1-0.1l15.6-9
							l15.7-5.1l15.6-16.2c0.1-0.1,0.1-0.1,0.2-0.1l15.6-5.7l15.6-18c0.1-0.1,0.1-0.1,0.2-0.1l15.5-4.5l15.6-49.6
							c0.1-0.2,0.2-0.3,0.4-0.3c0.2,0,0.4,0.1,0.5,0.2l15.6,27l15.5,0l15.4,0l15.6-27c0.1-0.1,0.2-0.2,0.3-0.2l15.6-5.2l15.6-21.9
							c0.1-0.1,0.2-0.2,0.4-0.2l31.3,0l15.6-9c0.2-0.1,0.5-0.1,0.7,0.2c0.1,0.2,0.1,0.5-0.2,0.7l-15.7,9.1c-0.1,0-0.2,0.1-0.2,0.1
							l-31.2,0l-15.6,21.8c-0.1,0.1-0.1,0.1-0.2,0.2l-15.5,5.2l-15.6,27c-0.1,0.1-0.2,0.2-0.4,0.2l0,0l-15.7,0l-15.7,0l0,0
							c-0.2,0-0.3-0.1-0.4-0.2l-15.2-26.2l-15.4,48.8c0,0.2-0.2,0.3-0.3,0.3l-15.6,4.5l-15.6,18c-0.1,0.1-0.1,0.1-0.2,0.1L577,492
							l-15.6,16.2c-0.1,0.1-0.1,0.1-0.2,0.1l-15.7,5.1l-15.4,8.9l-15.8,18.2C514.1,540.6,514,540.7,513.8,540.7z"/>
					</g>
				</g>
                    <g>
					<path class="st662" d="M513.9,550.2c-0.3,0-0.7-0.2-0.8-0.5c-0.3-0.5-0.1-1.1,0.4-1.3l266.9-154.1c0.5-0.3,1.1-0.1,1.3,0.4
						c0.3,0.5,0.1,1.1-0.4,1.3L514.4,550.1C514.2,550.1,514.1,550.2,513.9,550.2z"/>
                      <g>
						<g>
							<g>
								<g>
									<path class="st702"
                        d="M513.9,528.8c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S512.8,529.4,513.9,528.8z"/>
								</g>
                <g>
									<path class="st702" d="M529.6,501.6c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C527.6,503.8,528.5,502.2,529.6,501.6z"/>
								</g>
                <g>
									<path class="st702" d="M545.3,498.2c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C543.3,500.4,544.2,498.8,545.3,498.2z"/>
								</g>
                <g>
									<path class="st702" d="M561,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C559,467.5,559.9,465.9,561,465.3z"/>
								</g>
                <g>
									<path class="st702" d="M576.7,474.4c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C574.7,476.6,575.6,475,576.7,474.4z"/>
								</g>
                <g>
									<path class="st702" d="M592.4,469.8c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										S591.3,470.5,592.4,469.8z"/>
								</g>
                <g>
									<path class="st702" d="M608.1,456.2c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S607,456.9,608.1,456.2z
										"/>
								</g>
                <g>
									<path class="st702" d="M623.8,438.1c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2
										C621.8,440.3,622.7,438.7,623.8,438.1z"/>
								</g>
                <g>
									<path class="st702" d="M639.5,433.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2
										C637.5,435.8,638.4,434.2,639.5,433.6z"/>
								</g>
                <g>
									<path class="st702" d="M655.2,420c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C653.2,422.2,654.1,420.6,655.2,420z"/>
								</g>
                <g>
									<path class="st702" d="M670.9,420c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5s-2,0.1-2-1.2
										C668.9,422.2,669.8,420.6,670.9,420z"/>
								</g>
                <g>
									<path class="st702" d="M686.6,383.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C684.6,385.9,685.5,384.4,686.6,383.7z"/>
								</g>
                <g>
									<path class="st702" d="M702.3,401.7c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C700.3,403.9,701.2,402.4,702.3,401.7z"/>
								</g>
                <g>
									<path class="st702"
                        d="M718,383.7c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S716.9,384.4,718,383.7z"/>
								</g>
                <g>
									<path class="st702" d="M733.7,374.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C731.7,376.9,732.6,375.3,733.7,374.6z"/>
								</g>
                <g>
									<path class="st702" d="M749.4,374.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										C747.4,376.9,748.3,375.3,749.4,374.6z"/>
								</g>
                <g>
									<path class="st702" d="M765.1,365.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S764,366.2,765.1,365.6z
										"/>
								</g>
                <g>
									<path class="st702" d="M780.8,365.6c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
										S779.7,366.2,780.8,365.6z"/>
								</g>
							</g>
              <g>
								<path class="st702" d="M513.9,531.6c-0.1,0-0.2,0-0.2-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l15.8-27.3c0.1-0.1,0.2-0.2,0.3-0.2
									l15.4-3.3l15.6-32.7c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0,0.3,0,0.4,0l15.5,9l15.4-4.5l15.6-13.5l15.7-18.1
									c0.1-0.1,0.1-0.1,0.2-0.1l15.6-4.5l15.6-13.5c0.1-0.1,0.2-0.1,0.3-0.1h15.4l15.6-36c0.1-0.2,0.2-0.3,0.4-0.3
									c0.2,0,0.3,0,0.4,0.2l15.3,17.7l15.3-17.7c0,0,0.1-0.1,0.1-0.1l15.8-9.1c0.1,0,0.2-0.1,0.2-0.1h15.6l15.5-9
									c0.1,0,0.2-0.1,0.2-0.1h15.7c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5h-15.6l-15.5,9c-0.1,0-0.2,0.1-0.2,0.1h-15.6l-15.6,9
									l-15.6,18.1c-0.2,0.2-0.5,0.2-0.7,0l-15.2-17.6l-15.4,35.6c-0.1,0.2-0.3,0.3-0.4,0.3h-15.5l-15.6,13.5
									c-0.1,0-0.1,0.1-0.2,0.1l-15.6,4.5l-15.6,18l-15.7,13.6c-0.1,0-0.1,0.1-0.2,0.1l-15.7,4.5c-0.1,0-0.3,0-0.4,0l-15.3-8.8
									l-15.5,32.4c-0.1,0.1-0.2,0.2-0.3,0.3l-15.4,3.3l-15.7,27.1C514.2,531.5,514.1,531.6,513.9,531.6z"/>
							</g>
						</g>
					</g>
                      <g>
						<path class="st662" d="M522.1,461.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7
							C520.7,463,521.3,461.9,522.1,461.5z"/>
                        <g>
							<path class="st704" d="M513.9,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C511.9,467.5,512.8,465.9,513.9,465.3z"/>
                          <path class="st707" d="M513.9,465.3c1.1-0.6,2-0.1,2,1.2c0,1.3-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2
								C511.9,467.5,512.8,465.9,513.9,465.3z"/>
						</g>
					</g>
                      <g>
						<path class="st662" d="M522.1,470.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8
							c-0.8,0.4-1.4,0.1-1.4-0.7C520.7,472,521.3,471,522.1,470.5z"/>
                        <g>
							<path class="st704"
                    d="M513.9,474.4c1.1-0.6,2-0.1,2,1.2s-0.9,2.9-2,3.5c-1.1,0.6-2,0.1-2-1.2S512.8,475,513.9,474.4z"/>
						</g>
					</g>
				</g>
                    <g>
					<g>
						<g>
							<path class="st702" d="M513.9,595.2c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l8-8.2l7.8-1l7.9-10.2l7.9,1.1l7.7-6.9
								l7.8-4.7l8-11.1l7.9,2.5l7.6-6.8c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-8,7.2l-7.8-2.4l-7.8,10.7l-7.9,4.7l-7.9,7.2
								l-7.8-1.1l-7.8,10.1l-7.9,1l-7.7,7.9C514.1,595.1,514,595.2,513.9,595.2z"/>
						</g>
            <g>
							<path class="st706" d="M517,568.7c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.1c0.4-0.2,0.8-0.4,1.2-0.4
								c0.4,0,0.7,0.1,0.9,0.4c0.3,0.2,0.5,0.6,0.6,1c0.1,0.4,0.2,1,0.2,1.6c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.4,1.2-0.6,1.7
								c-0.3,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.8,0.8-1.2,1c-0.4,0.2-0.8,0.4-1.2,0.4c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.2-0.5-0.6-0.6-1
								c-0.1-0.4-0.2-0.9-0.2-1.6c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.8
								l2.1-5.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2
								c0,0,0,0.1,0,0.1L517,568.7z M515.5,573.7c0,0.4,0,0.7,0.1,0.9c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.4,0.2,0.6,0.3
								c0.2,0,0.5-0.1,0.8-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.4,0.1-0.7,0.1-1.1
								c0-0.4,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.5,0.1-0.8,0.2s-0.6,0.4-0.8,0.7
								c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.3,0.7-0.4,1.1C515.6,573,515.5,573.3,515.5,573.7z"/>
              <path class="st706" d="M522.3,570.8c0,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0
								c0.2,0,0.5-0.2,0.9-0.4c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1.1
								c0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.4c-0.2-0.1-0.3-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.7,0.3l-1,0.6c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.1-4.6l-3.3,1.9c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l4.5-2.6c0.1,0,0.2,0,0.2,0
								c0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.4l-2,4.6c0.4-0.2,0.7-0.3,1.1-0.3
								c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.4,0.2,0.8,0.2,1.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.1-0.6,1.6
								c-0.3,0.5-0.6,0.9-0.9,1.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.5-1.3,0.5c-0.4,0-0.7,0-0.9-0.2c-0.2-0.2-0.4-0.4-0.5-0.7
								c-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2l0.5-0.3c0.1,0,0.2,0,0.2,0
								C522.3,570.7,522.3,570.8,522.3,570.8z"/>
              <path class="st706" d="M529.2,566.9c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0
								c0.2,0,0.5-0.2,0.9-0.4c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1.1
								c0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.4c-0.2-0.1-0.3-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.7,0.3l-1,0.6c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.1-4.6l-3.3,1.9c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l4.5-2.6c0.1,0,0.2,0,0.2,0
								c0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.4l-2,4.6c0.4-0.2,0.7-0.3,1-0.3
								c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.4,0.2,0.8,0.2,1.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.1-0.6,1.6
								c-0.3,0.5-0.6,0.9-0.9,1.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.5-1.3,0.5c-0.4,0-0.7,0-0.9-0.2c-0.2-0.2-0.4-0.4-0.5-0.7
								c-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2l0.5-0.3c0.1,0,0.2,0,0.2,0
								C529.1,566.7,529.2,566.8,529.2,566.9z"/>
						</g>
            <g>
							<path class="st662" d="M515.3,601.4l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-67.8,39.3
								c-0.8,0.4-1.4,0.1-1.4-0.7C513.9,602.9,514.5,601.9,515.3,601.4z"/>
						</g>
            <g>
							<path class="st662" d="M515.3,556.1l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8
								c-0.8,0.4-1.4,0.1-1.4-0.7C513.9,557.5,514.5,556.5,515.3,556.1z"/>
						</g>
					</g>
                      <g>
						<g>
							<path class="st704" d="M513.9,649.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l8-8.2l7.9-1l7.9-6.9l7.6-2.1l8-15.9l8,3.9
								l7.7-6.8l0.1,0l7.7-1.5l7.7-13.4c0.1-0.2,0.4-0.3,0.7-0.2c0.2,0.1,0.3,0.4,0.2,0.7l-7.9,13.7l-8,1.5l-8,7l-7.7-3.8l-7.7,15.4
								l-8,2.2l-7.9,6.9l-7.8,1l-7.7,7.9C514.1,649.5,514,649.5,513.9,649.5z"/>
						</g>
                        <g class="st707">
							<path d="M513.9,649.5c-0.1,0-0.2,0-0.3-0.1c-0.2-0.2-0.2-0.5,0-0.7l8-8.2l7.9-1l7.9-6.9l7.6-2.1l8-15.9l8,3.9l7.7-6.8l0.1,0
								l7.7-1.5l7.7-13.4c0.1-0.2,0.4-0.3,0.7-0.2c0.2,0.1,0.3,0.4,0.2,0.7l-7.9,13.7l-8,1.5l-8,7l-7.7-3.8l-7.7,15.4l-8,2.2
								l-7.9,6.9l-7.8,1l-7.7,7.9C514.1,649.5,514,649.5,513.9,649.5z"/>
						</g>
                        <g>
							<path class="st706" d="M517.9,630.3c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-0.5,0.3c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-9.7l-1.9,3.3c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.2,0-0.2-0.1l-0.3-0.4c-0.1-0.1-0.1-0.2-0.1-0.3
								c0-0.1,0.1-0.3,0.1-0.4l2.5-4.3c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1-0.1,0.2-0.1l0.5-0.3c0.1,0,0.2,0,0.2,0
								c0.1,0.1,0.1,0.2,0.1,0.3V630.3z"/>
                          <path class="st706" d="M522.9,621.3c0.2-0.5,0.4-0.9,0.5-1.3c0.1-0.4,0.2-0.9,0.2-1.4c0-0.6-0.1-1.1-0.4-1.4
								c-0.2-0.3-0.6-0.3-1.1,0c-0.3,0.2-0.5,0.3-0.7,0.6c-0.2,0.2-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.3,0.9
								c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.2l-0.5,0.3c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.2
								c0-0.4,0.1-0.9,0.2-1.4c0.1-0.5,0.3-1,0.5-1.5c0.2-0.5,0.5-1,0.8-1.4c0.3-0.4,0.7-0.8,1.1-1c0.4-0.2,0.8-0.4,1.1-0.3
								c0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.4,0.5,0.5,0.9c0.1,0.4,0.2,0.9,0.2,1.4c0,0.4,0,0.7-0.1,1.1c0,0.3-0.1,0.7-0.2,1
								c-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.3,0.7-0.5,1.1l-2.6,5.2l3.5-2c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.3v0.6
								c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-5,2.9c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6
								c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.2-0.5L522.9,621.3z"/>
                          <path class="st706" d="M532,614.9c0,0.5,0,1,0,1.5s0,1,0,1.5c0,0.7-0.1,1.4-0.2,2c-0.1,0.7-0.3,1.3-0.5,1.9
								c-0.2,0.6-0.5,1.1-0.9,1.5c-0.4,0.5-0.8,0.8-1.3,1.1c-0.5,0.3-0.9,0.4-1.3,0.4c-0.4,0-0.7-0.2-0.9-0.5
								c-0.2-0.3-0.4-0.7-0.5-1.2c-0.1-0.5-0.2-1.1-0.2-1.8c0-0.5,0-1,0-1.5s0-1,0-1.5c0-0.7,0.1-1.4,0.2-2c0.1-0.7,0.3-1.3,0.5-1.9
								c0.2-0.6,0.5-1.1,0.9-1.6c0.4-0.5,0.8-0.8,1.3-1.1c0.5-0.3,0.9-0.4,1.3-0.4c0.4,0,0.7,0.2,0.9,0.5c0.2,0.3,0.4,0.7,0.5,1.2
								C531.9,613.6,532,614.2,532,614.9z M527.2,620.7c0,1.1,0.2,1.8,0.5,2.2c0.3,0.4,0.8,0.4,1.4,0c0.6-0.3,1.1-0.9,1.4-1.6
								c0.3-0.7,0.5-1.6,0.5-2.8c0-0.5,0-1,0-1.5c0-0.5,0-1,0-1.5c0-1.1-0.2-1.8-0.5-2.2c-0.3-0.4-0.8-0.4-1.4,0
								c-0.6,0.3-1.1,0.9-1.4,1.6c-0.3,0.7-0.5,1.6-0.5,2.8c0,0.5,0,1,0,1.5C527.2,619.6,527.2,620.1,527.2,620.7z"/>
						</g>
                        <g>
							<path class="st662" d="M515.3,655.8l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-67.8,39.3
								c-0.8,0.4-1.4,0.1-1.4-0.7C513.9,657.2,514.5,656.2,515.3,655.8z"/>
						</g>
                        <g>
							<path class="st662" d="M515.3,610.4l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8
								c-0.8,0.4-1.4,0.1-1.4-0.7C513.9,611.9,514.5,610.8,515.3,610.4z"/>
						</g>
					</g>
                      <g>
						<g>
							<path class="st702" d="M608.1,540.7c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.1-0.5,0.1-0.7l7.9-6.3l7.9-9l8-1.2l7.7-1.7l7.9-9.4
								l7.8,1.4l7.8-12.4l8,0.1l7.7-6.9c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-8,7.1l-7.8-0.1l-7.9,12.5l-7.9-1.4l-7.8,9.2
								l-8,1.8l-7.7,1.1l-7.7,8.8l-7.9,6.3C608.3,540.6,608.2,540.7,608.1,540.7z"/>
						</g>
                        <g>
							<path class="st706" d="M611.2,514.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.2-0.1,0.2-0.1c0.4-0.2,0.8-0.4,1.2-0.4
								c0.4,0,0.7,0.1,0.9,0.4c0.3,0.2,0.5,0.6,0.6,1c0.1,0.4,0.2,1,0.2,1.6c0,0.6-0.1,1.2-0.2,1.8c-0.1,0.6-0.4,1.2-0.6,1.7
								c-0.3,0.5-0.6,1-0.9,1.4c-0.4,0.4-0.8,0.8-1.2,1c-0.4,0.2-0.8,0.4-1.2,0.4c-0.4,0-0.7-0.1-0.9-0.4c-0.3-0.2-0.5-0.6-0.6-1
								c-0.1-0.4-0.2-0.9-0.2-1.6c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.8
								l2.1-5.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.1,0,0.2
								c0,0,0,0.1,0,0.1L611.2,514.1z M609.7,519.2c0,0.4,0,0.7,0.1,0.9c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.2,0.4,0.2,0.6,0.3
								c0.2,0,0.5-0.1,0.8-0.2c0.3-0.2,0.6-0.4,0.8-0.7c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.4,0.1-0.7,0.1-1.1
								c0-0.4,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.6c-0.2-0.2-0.4-0.2-0.6-0.2c-0.2,0-0.5,0.1-0.8,0.2c-0.3,0.2-0.6,0.4-0.8,0.7
								c-0.2,0.3-0.4,0.6-0.6,0.9c-0.2,0.3-0.3,0.7-0.4,1.1C609.8,518.5,609.7,518.8,609.7,519.2z"/>
                          <path class="st706" d="M619.2,511.3c0.2-0.5,0.4-0.9,0.5-1.3c0.1-0.4,0.2-0.9,0.2-1.4c0-0.6-0.1-1.1-0.4-1.4
								c-0.2-0.3-0.6-0.3-1.1,0c-0.3,0.2-0.5,0.3-0.7,0.6c-0.2,0.2-0.3,0.5-0.5,0.8c-0.1,0.3-0.2,0.6-0.3,0.9
								c-0.1,0.3-0.1,0.6-0.2,0.9c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.2l-0.5,0.3c-0.1,0-0.1,0-0.2,0c0,0-0.1-0.1-0.1-0.2
								c0-0.4,0.1-0.9,0.2-1.4c0.1-0.5,0.3-1,0.5-1.5c0.2-0.5,0.5-1,0.8-1.4c0.3-0.4,0.7-0.8,1.1-1c0.4-0.2,0.8-0.4,1.1-0.3
								c0.3,0,0.6,0.1,0.8,0.4c0.2,0.2,0.4,0.5,0.5,0.9c0.1,0.4,0.2,0.9,0.2,1.4c0,0.4,0,0.7-0.1,1.1c0,0.3-0.1,0.7-0.2,1
								c-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.3,0.7-0.5,1.1l-2.6,5.2l3.5-2c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.3v0.6
								c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-5,2.9c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6
								c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.3,0.2-0.5L619.2,511.3z"/>
                          <path class="st706" d="M627,500.9c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2,0,0.4c0,0.1-0.1,0.3-0.1,0.4
								l-2.6,11.6c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.1-0.1,0.2-0.2,0.3l-0.5,0.3c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.1-0.1-0.1-0.3
								c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.2l2.6-11.6l-3.8,2.2c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4
								c0.1-0.1,0.1-0.2,0.2-0.3L627,500.9z"/>
						</g>
                        <g>
							<path class="st662" d="M609.5,546.9l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-67.8,39.3
								c-0.8,0.4-1.4,0.1-1.4-0.7C608.1,548.4,608.8,547.3,609.5,546.9z"/>
						</g>
                        <g>
							<path class="st662" d="M609.5,501.5l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8
								c-0.8,0.4-1.4,0.1-1.4-0.7S608.8,502,609.5,501.5z"/>
						</g>
					</g>
                      <g>
						<g>
							<path class="st704" d="M608.1,595c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l8-13.2l8.1,1.5l7.6-2.1l7.9-9.6l7.8-2
								l7.9-14.1l8.1,2.4l7.6-1.4l7.7-6.9c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-7.9,7.1l-0.1,0l-8,1.5l-7.6-2.2l-7.8,13.8
								l-7.9,2l-7.8,9.6l-0.1,0l-8,2.2l-0.1,0l-7.5-1.4l-7.7,12.6C608.4,594.9,608.3,595,608.1,595z"/>
						</g>
                        <g class="st707">
							<path d="M608.1,595c-0.1,0-0.2,0-0.3-0.1c-0.2-0.1-0.3-0.4-0.2-0.7l8-13.2l8.1,1.5l7.6-2.1l7.9-9.6l7.8-2l7.9-14.1l8.1,2.4
								l7.6-1.4l7.7-6.9c0.2-0.2,0.5-0.2,0.7,0c0.2,0.2,0.2,0.5,0,0.7l-7.9,7.1l-0.1,0l-8,1.5l-7.6-2.2l-7.8,13.8l-7.9,2l-7.8,9.6
								l-0.1,0l-8,2.2l-0.1,0l-7.5-1.4l-7.7,12.6C608.4,594.9,608.3,595,608.1,595z"/>
						</g>
                        <g>
							<path class="st706" d="M611.7,572.2c0,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.1c-0.4,0.2-0.7,0.3-1.1,0.3
								c-0.3,0-0.7-0.1-0.9-0.3c-0.3-0.2-0.5-0.5-0.6-0.9c-0.2-0.4-0.2-1-0.2-1.6c0-0.6,0.1-1.2,0.2-1.8c0.2-0.6,0.4-1.2,0.6-1.7
								c0.3-0.5,0.6-1,0.9-1.4c0.3-0.4,0.7-0.7,1.1-1c0.4-0.3,0.8-0.4,1.2-0.4c0.4,0,0.7,0.1,0.9,0.4s0.4,0.6,0.6,1
								c0.1,0.4,0.2,0.9,0.2,1.5c0,0.3,0,0.6-0.1,0.9c-0.1,0.3-0.1,0.7-0.2,1c-0.1,0.3-0.2,0.7-0.3,1c-0.1,0.3-0.2,0.6-0.3,0.9
								l-2.1,5.9c0,0.1-0.1,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3l-0.7,0.4c-0.1,0-0.1,0-0.2,0c0-0.1-0.1-0.1-0.1-0.2
								c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1L611.7,572.2z M613.2,567.2c0-0.4,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.5-0.4-0.6
								c-0.2-0.1-0.3-0.2-0.6-0.2c-0.2,0-0.5,0.1-0.7,0.2c-0.3,0.2-0.5,0.4-0.7,0.6c-0.2,0.3-0.4,0.5-0.6,0.9
								c-0.2,0.3-0.3,0.7-0.4,1c-0.1,0.4-0.1,0.7-0.1,1.1c0,0.4,0,0.7,0.1,1c0.1,0.3,0.2,0.5,0.4,0.6c0.2,0.1,0.3,0.2,0.6,0.2
								c0.2,0,0.5-0.1,0.7-0.2c0.3-0.1,0.5-0.4,0.7-0.6c0.2-0.3,0.4-0.5,0.6-0.9c0.2-0.3,0.3-0.7,0.4-1
								C613.2,568,613.2,567.6,613.2,567.2z"/>
                          <path class="st706" d="M616.2,570.9c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.2,0.3,0.3,0.3c0.1,0.1,0.3,0.1,0.5,0
								c0.2,0,0.5-0.2,0.9-0.4c0.2-0.1,0.5-0.3,0.7-0.5c0.2-0.2,0.4-0.5,0.6-0.7c0.2-0.3,0.3-0.6,0.4-0.9c0.1-0.3,0.1-0.7,0.1-1.1
								c0-0.4,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.4-0.4c-0.2-0.1-0.3-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.7,0.3l-1,0.6c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.3l2.1-4.6l-3.3,1.9c-0.1,0-0.2,0-0.2,0
								c-0.1-0.1-0.1-0.2-0.1-0.3v-0.6c0-0.1,0-0.3,0.1-0.4c0.1-0.1,0.1-0.2,0.2-0.3l4.5-2.6c0.1,0,0.2,0,0.2,0
								c0.1,0.1,0.1,0.2,0.1,0.3v0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.4l-2,4.6c0.4-0.2,0.7-0.3,1.1-0.3
								c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.4,0.5,0.5,0.8c0.1,0.4,0.2,0.8,0.2,1.4c0,0.6-0.1,1.2-0.2,1.8c-0.2,0.6-0.4,1.1-0.6,1.6
								c-0.3,0.5-0.6,0.9-0.9,1.3c-0.3,0.4-0.7,0.7-1.1,0.9c-0.5,0.3-1,0.5-1.3,0.5c-0.4,0-0.7,0-0.9-0.2c-0.2-0.2-0.4-0.4-0.5-0.7
								c-0.1-0.3-0.2-0.6-0.2-1c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.2-0.2l0.5-0.3c0.1,0,0.2,0,0.2,0
								C616.2,570.7,616.2,570.8,616.2,570.9z"/>
						</g>
                        <g>
							<path class="st662" d="M609.5,601.2l67.8-39.3c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-67.8,39.3
								c-0.8,0.4-1.4,0.1-1.4-0.7C608.1,602.7,608.8,601.7,609.5,601.2z"/>
						</g>
                        <g>
							<path class="st662" d="M609.5,555.9l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-15.2,8.8
								c-0.8,0.4-1.4,0.1-1.4-0.7C608.1,557.4,608.8,556.3,609.5,555.9z"/>
						</g>
					</g>
				</g>
                    <g>
					<g>
						<g id="XMLID_00000171715448927488871300000016755852840781911992_">
							<g id="XMLID_00000050647768736877917830000011115756016315312827_">
								<g id="XMLID_00000128480443285204937890000008173738891503808143_">
									<path id="XMLID_00000134945125124822296590000012617453484956260537_" class="st704" d="M710.2,452.4
										c3.3-1.9,6.4-2,8.9-0.7l-8.9,24.1V452.4z"/>
                  <path id="XMLID_00000160878061321649542690000003593827935555236482_" class="st704" d="M701.2,462.1
										c2.5-4.3,5.6-7.7,8.9-9.7v23.5L701.2,462.1z"/>
                  <path id="XMLID_00000162344988633010506890000005327940534966527418_" class="st704" d="M695.7,477c1-5.3,3-10.5,5.5-14.9
										l8.9,13.8L695.7,477z"/>
                  <path class="st707"
                        d="M701.2,462.1c-2.6,4.4-4.5,9.6-5.5,14.9l14.5-1.1v-23.5C706.8,454.4,703.7,457.8,701.2,462.1z"/>
                  <path id="XMLID_00000008858587095391995300000016650367862011548056_" class="st704" d="M719.1,451.8
										c2.6,1.4,4.5,4.3,5.5,8.5l-14.5,15.6L719.1,451.8z"/>
                  <path id="XMLID_00000000184229558696108770000006743288702958515358_" class="st704" d="M695.7,491.5
										c-0.5-2-0.7-4.3-0.7-6.8c0-2.5,0.3-5.1,0.7-7.7l14.5-1.1L695.7,491.5z"/>
                  <path id="XMLID_00000115487986007702887130000005691016456329780368_" class="st704" d="M724.7,474.8
										c-1,5.3-3,10.5-5.5,14.9l-8.9-13.8L724.7,474.8z"/>
                  <path id="XMLID_00000107564248386862012940000010470765539112299183_" class="st704" d="M710.2,499.4
										c-3.3,1.9-6.4,2-8.9,0.7l8.9-24.1V499.4z"/>
                  <path id="XMLID_00000172439280404129736720000015859720207444335009_" class="st704" d="M695.7,491.5l14.5-15.6l-8.9,24.1
										C698.6,498.6,696.7,495.7,695.7,491.5z"/>
                  <path id="XMLID_00000049200271636171200030000005953279509472527522_" class="st704" d="M724.7,460.3
										c0.5,2,0.7,4.3,0.7,6.8c0,2.5-0.3,5.1-0.7,7.7l-14.5,1.1L724.7,460.3z"/>
                  <path id="XMLID_00000055699388702538029340000009946710495301125557_" class="st704" d="M719.1,489.7
										c-2.5,4.3-5.6,7.7-8.9,9.7v-23.5L719.1,489.7z"/>
								</g>
							</g>
						</g>
            <g>
							<path class="st706" d="M702.6,511.3l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7
								C701.2,512.8,701.8,511.8,702.6,511.3z"/>
              <path class="st662" d="M699.2,522.4l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7
								c-0.8,0.4-1.4,0.1-1.4-0.7C697.8,523.8,698.4,522.8,699.2,522.4z"/>
              <path class="st662" d="M699.2,531.4l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-21.9,12.7
								c-0.8,0.4-1.4,0.1-1.4-0.7C697.8,532.9,698.4,531.9,699.2,531.4z"/>
              <path class="st662" d="M699.2,540.5l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7c0,0.8-0.6,1.9-1.4,2.3l-21.9,12.7
								c-0.8,0.4-1.4,0.1-1.4-0.7C697.8,542,698.4,541,699.2,540.5z"/>
						</g>
					</g>
                      <g>
						<g id="XMLID_00000071532111392644019450000004361671073668143005_">
							<g id="XMLID_00000026856415536110031660000013530390095282445451_">
								<g id="XMLID_00000018221669484121832310000002808444600002141864_">
									<path id="XMLID_00000143617521604918258260000007303595142050411455_" class="st704" d="M765.1,420.6
										c3.3-1.9,6.4-2,8.9-0.7l-8.9,24.1V420.6z"/>
                  <path id="XMLID_00000088813138016767377010000017457665404543660184_" class="st704" d="M756.2,430.3
										c2.5-4.3,5.6-7.7,8.9-9.7v23.5L756.2,430.3z"/>
                  <path id="XMLID_00000132055433379871220920000005346629718066114482_" class="st704" d="M750.6,445.2
										c1-5.3,3-10.5,5.5-14.9l8.9,13.8L750.6,445.2z"/>
                  <path id="XMLID_00000163043715744964712980000010215212315953261498_" class="st704" d="M774.1,419.9
										c2.6,1.4,4.5,4.3,5.5,8.5l-14.5,15.6L774.1,419.9z"/>
                  <path id="XMLID_00000150814861355898096730000007226763260526139046_" class="st704" d="M750.6,459.7
										c-0.5-2-0.7-4.3-0.7-6.8c0-2.5,0.3-5.1,0.7-7.7l14.5-1.1L750.6,459.7z"/>
                  <path id="XMLID_00000038377266033459602370000004162581052014154910_" class="st704" d="M779.6,442.9
										c-1,5.3-3,10.5-5.5,14.9l-8.9-13.8L779.6,442.9z"/>
                  <path id="XMLID_00000026850739906559917830000012058698411113521826_" class="st704" d="M765.1,467.5
										c-3.3,1.9-6.4,2-8.9,0.7l8.9-24.1V467.5z"/>
                  <path id="XMLID_00000020373423992632858310000014232455436360460171_" class="st704" d="M750.6,459.7l14.5-15.6l-8.9,24.1
										C753.6,466.8,751.6,463.8,750.6,459.7z"/>
                  <path class="st707" d="M756.2,430.3c-2.6,4.4-4.5,9.6-5.5,14.9c-0.5,2.6-0.7,5.2-0.7,7.7c0,2.5,0.3,4.8,0.7,6.8
										c1,4.2,3,7.1,5.5,8.5l8.9-24.1v-23.5C761.8,422.5,758.7,426,756.2,430.3z"/>
                  <path id="XMLID_00000096057045127280664680000017872093713379500219_" class="st704" d="M779.6,428.4
										c0.5,2,0.7,4.3,0.7,6.8s-0.3,5.1-0.7,7.7l-14.5,1.1L779.6,428.4z"/>
                  <path id="XMLID_00000049199312788545023290000014634106171240222136_" class="st704" d="M774.1,457.8
										c-2.5,4.3-5.6,7.7-8.9,9.7v-23.5L774.1,457.8z"/>
								</g>
							</g>
						</g>
                        <g>
							<path class="st706" d="M757.5,479.6l15.2-8.8c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-15.2,8.8c-0.8,0.4-1.4,0.1-1.4-0.7
								C756.1,481.1,756.8,480,757.5,479.6z"/>
                          <path class="st662" d="M754.2,490.6l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7
								c-0.8,0.4-1.4,0.1-1.4-0.7C752.8,492.1,753.4,491.1,754.2,490.6z"/>
                          <path class="st662" d="M754.2,499.7l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7
								c-0.8,0.4-1.4,0.1-1.4-0.7C752.8,501.2,753.4,500.2,754.2,499.7z"/>
                          <path class="st662" d="M754.2,508.8l21.9-12.7c0.8-0.4,1.4-0.1,1.4,0.7s-0.6,1.9-1.4,2.3l-21.9,12.7
								c-0.8,0.4-1.4,0.1-1.4-0.7C752.8,510.3,753.4,509.2,754.2,508.8z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>
        </div>
      </template>
      <span>Price Watcher</span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * @component PriceWatcherButton
 * Home button component that redirects to Price Watcher page
 */
export default {
  name: 'PriceWatcherButton',
  props: {
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToPriceWatcherPage() {
      this.$router.push('/price-watcher');
    }
  }
}

</script>

<style lang="scss" scoped>
.main-light {
  .home-button {
    background-color: rgba(0, 0, 0, 0.15);
    border: 4px solid #5c9485;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);

    &:hover {
      background-color: rgb(255, 255, 255);
      border: 4px solid #4ABD96 !important;
      box-shadow: 5px 5px 14px rgba(0, 0, 0, 0.7);
      cursor: pointer;
      z-index: 99999;
      transform: scale(1.1);
    }
  }
}
</style>

<style scoped>
.st0 {
  clip-path: url(#SVGID_00000054259513457042731930000000637713291433154740_);
}

.st1 {
  clip-path: url(#SVGID_00000067953603896057967220000001225026532553369230_);
  enable-background: new;
}

.st2 {
  clip-path: url(#SVGID_00000165916337629157283440000011869485159254157995_);
}

.st3 {
  clip-path: url(#SVGID_00000150099336687075930140000010629887429676631184_);
}

.st4 {
  opacity: 0;
  clip-path: url(#SVGID_00000124873368895978039010000011134251830822400655_);
}

.st5 {
  opacity: 0;
}

.st6 {
  clip-path: url(#SVGID_00000145049241126628458850000014255597346806516154_);
}

.st7 {
  clip-path: url(#SVGID_00000178890591919168043320000009429784890408191156_);
}

.st8 {
  clip-path: url(#SVGID_00000093144979498482753230000015529150470018325690_);
  fill: #3FB994;
}

.st9 {
  clip-path: url(#SVGID_00000106839887573347324640000016064275031932514712_);
}

.st10 {
  clip-path: url(#SVGID_00000109000849205944385220000000021014250611489685_);
  enable-background: new;
}

.st11 {
  clip-path: url(#SVGID_00000183230658139099685560000018146375272694052274_);
}

.st12 {
  clip-path: url(#SVGID_00000109724199154563668060000005807268204103950486_);
}

.st13 {
  clip-path: url(#SVGID_00000003798767766106021160000015386986571456779709_);
  fill: #3FB994;
}

.st14 {
  clip-path: url(#SVGID_00000129182323935641708970000005478491388630326695_);
}

.st15 {
  clip-path: url(#SVGID_00000029010408244119004690000003212430778269683643_);
}

.st16 {
  clip-path: url(#SVGID_00000170961540591811541500000011436986586397943710_);
  fill: #3FB994;
}

.st17 {
  clip-path: url(#SVGID_00000091731612917016743850000010375693428038012289_);
}

.st18 {
  clip-path: url(#SVGID_00000096773610499613191890000016344166898204949654_);
}

.st19 {
  clip-path: url(#SVGID_00000129900939268599008900000018053897490843447960_);
  fill: #3FB994;
}

.st20 {
  clip-path: url(#SVGID_00000134969961811236214450000006213839257223711108_);
}

.st21 {
  clip-path: url(#SVGID_00000004542283555840682700000012702745660025228454_);
}

.st22 {
  clip-path: url(#SVGID_00000070812953975961980210000007206248776114961795_);
  fill: #3FB994;
}

.st23 {
  clip-path: url(#SVGID_00000170266507151412821460000012653190361738339512_);
}

.st24 {
  clip-path: url(#SVGID_00000166635218275485264970000016307874085020995738_);
}

.st25 {
  clip-path: url(#SVGID_00000017510180491842479420000011832963150444466609_);
  fill: #3FB994;
}

.st26 {
  clip-path: url(#SVGID_00000087390762344091974820000006261399918302654892_);
}

.st27 {
  clip-path: url(#SVGID_00000132782301936048278790000010481671925349441178_);
}

.st28 {
  clip-path: url(#SVGID_00000116920374402113215530000006907564482092089774_);
  fill: #3FB994;
}

.st29 {
  clip-path: url(#SVGID_00000130634045074945155440000015549067935137361583_);
}

.st30 {
  clip-path: url(#SVGID_00000026843809881657268770000002023881470310093196_);
}

.st31 {
  clip-path: url(#SVGID_00000038385103819632867520000015525121771632937356_);
  fill: #3FB994;
}

.st32 {
  clip-path: url(#SVGID_00000082349684735125864380000003295408708281245570_);
}

.st33 {
  clip-path: url(#SVGID_00000073704467232026878540000013550712017619204483_);
}

.st34 {
  clip-path: url(#SVGID_00000183211498903823426670000002602762882012549003_);
  fill: #3FB994;
}

.st35 {
  clip-path: url(#SVGID_00000113342559454937728850000000451349752536489363_);
}

.st36 {
  clip-path: url(#SVGID_00000145765611957017632830000017852632723045405085_);
}

.st37 {
  clip-path: url(#SVGID_00000009551322672021172400000002331592372357237128_);
  fill: #3FB994;
}

.st38 {
  clip-path: url(#SVGID_00000003818646362887462580000003762079231770362532_);
}

.st39 {
  clip-path: url(#SVGID_00000005266144532064602170000008772108314163447956_);
}

.st40 {
  clip-path: url(#SVGID_00000036971959990998779650000010543523714357272735_);
  fill: #3FB994;
}

.st41 {
  clip-path: url(#SVGID_00000083054954459913423270000015623906750840027828_);
}

.st42 {
  clip-path: url(#SVGID_00000022558182632383421770000018089957612262564287_);
}

.st43 {
  clip-path: url(#SVGID_00000127723382417249504320000002353665030992455311_);
  fill: #3FB994;
}

.st44 {
  clip-path: url(#SVGID_00000149371890481528656750000007071648204771593873_);
}

.st45 {
  clip-path: url(#SVGID_00000115494773021263666000000012344288650762992793_);
}

.st46 {
  clip-path: url(#SVGID_00000158001830828740606620000001291143047516980378_);
  fill: #3FB994;
}

.st47 {
  clip-path: url(#SVGID_00000146463085386953428970000013592535801588481432_);
}

.st48 {
  clip-path: url(#SVGID_00000163042460606239600470000016635560096528844953_);
}

.st49 {
  clip-path: url(#SVGID_00000001638717267054773900000007842086513997966246_);
  fill: #3FB994;
}

.st50 {
  clip-path: url(#SVGID_00000023271436731795332330000005321061954861893049_);
}

.st51 {
  clip-path: url(#SVGID_00000019676381333011788290000015043708761260291753_);
  enable-background: new;
}

.st52 {
  clip-path: url(#SVGID_00000137838985633314564550000009241020355965495730_);
}

.st53 {
  clip-path: url(#SVGID_00000134946216867276488000000017216215501907729540_);
}

.st54 {
  clip-path: url(#SVGID_00000150809532919694418290000007202335651876065172_);
  fill: #306175;
}

.st55 {
  clip-path: url(#SVGID_00000137130731893991281240000018199981022456041871_);
}

.st56 {
  clip-path: url(#SVGID_00000101062546973256301050000007815121761269210301_);
}

.st57 {
  clip-path: url(#SVGID_00000044170540974892257120000004106595485371133884_);
  fill: #32657A;
}

.st58 {
  clip-path: url(#SVGID_00000121246231238353124900000015202878995162562730_);
}

.st59 {
  clip-path: url(#SVGID_00000103984984097296727980000007627101933332432274_);
}

.st60 {
  clip-path: url(#SVGID_00000177458061304178300280000016456468692994599078_);
  fill: #34697F;
}

.st61 {
  clip-path: url(#SVGID_00000171709084237960021570000002680389951967742594_);
}

.st62 {
  clip-path: url(#SVGID_00000065034280126740082820000015261741516452010677_);
}

.st63 {
  clip-path: url(#SVGID_00000129908595269062881950000004580411527083309462_);
  fill: #366C82;
}

.st64 {
  clip-path: url(#SVGID_00000100348781674824381950000006809265476134489529_);
}

.st65 {
  clip-path: url(#SVGID_00000014612797609678889490000017719982681163550356_);
  enable-background: new;
}

.st66 {
  clip-path: url(#SVGID_00000003801764849111982720000014903807454504511630_);
}

.st67 {
  clip-path: url(#SVGID_00000000908596665099583240000018013471076338996622_);
}

.st68 {
  opacity: 0;
  clip-path: url(#SVGID_00000093886464822805592140000008252839885596275336_);
}

.st69 {
  clip-path: url(#SVGID_00000074420210029560996620000002873361086390516146_);
}

.st70 {
  clip-path: url(#SVGID_00000165925454474785869320000013198364874589667260_);
}

.st71 {
  clip-path: url(#SVGID_00000080906375225418804750000012925664486664092855_);
  fill: #3FB994;
}

.st72 {
  clip-path: url(#SVGID_00000147943228997782198800000012110520798280955792_);
}

.st73 {
  clip-path: url(#SVGID_00000013892037344355884590000007764139375244281744_);
  enable-background: new;
}

.st74 {
  clip-path: url(#SVGID_00000082354340659937521550000012873289605970404745_);
}

.st75 {
  clip-path: url(#SVGID_00000156575718543906270120000004436791750168185274_);
}

.st76 {
  clip-path: url(#SVGID_00000137115795282805501800000003854425249964351126_);
  fill: #3FB994;
}

.st77 {
  clip-path: url(#SVGID_00000106865355450289372910000013449784013310223764_);
}

.st78 {
  clip-path: url(#SVGID_00000092445599027181972470000008702617297219170716_);
}

.st79 {
  clip-path: url(#SVGID_00000048476183746028333080000009837132158482230433_);
  fill: #3FB994;
}

.st80 {
  clip-path: url(#SVGID_00000150078650767700259750000002315957975900080018_);
}

.st81 {
  clip-path: url(#SVGID_00000078004451082882349300000016944433149800333209_);
}

.st82 {
  clip-path: url(#SVGID_00000046318656839479042560000005178345846187950526_);
  fill: #3FB994;
}

.st83 {
  clip-path: url(#SVGID_00000065754915075047094350000007313849802547673237_);
}

.st84 {
  clip-path: url(#SVGID_00000073684359326884344370000007675665992393328525_);
}

.st85 {
  clip-path: url(#SVGID_00000107586043330981612550000014920356624033937836_);
  fill: #3FB994;
}

.st86 {
  clip-path: url(#SVGID_00000060024395977787303390000009503610220669254840_);
}

.st87 {
  clip-path: url(#SVGID_00000042729064559388023050000008909717082658457522_);
}

.st88 {
  clip-path: url(#SVGID_00000062906759671964299840000013428683347642132644_);
  fill: #3FB994;
}

.st89 {
  clip-path: url(#SVGID_00000120557643525865314970000001015157117557467019_);
}

.st90 {
  clip-path: url(#SVGID_00000125587649833261271950000018361990299131807136_);
}

.st91 {
  clip-path: url(#SVGID_00000116193030578496160820000012307884209568017321_);
  fill: #3FB994;
}

.st92 {
  clip-path: url(#SVGID_00000111904710722208462520000003734618018516338872_);
}

.st93 {
  clip-path: url(#SVGID_00000018202948080807715730000012661764376394851997_);
}

.st94 {
  clip-path: url(#SVGID_00000170963807978688004130000012316223973058085782_);
  fill: #3FB994;
}

.st95 {
  clip-path: url(#SVGID_00000010297027426164948080000012801805057596288186_);
}

.st96 {
  clip-path: url(#SVGID_00000000906999306999897920000008310339167106120613_);
}

.st97 {
  clip-path: url(#SVGID_00000082350899897438572790000007332812602848823177_);
  fill: #3FB994;
}

.st98 {
  clip-path: url(#SVGID_00000024688493488136361900000013164662596440239258_);
}

.st99 {
  clip-path: url(#SVGID_00000151526070778709787420000013859958654646784392_);
}

.st100 {
  clip-path: url(#SVGID_00000079446458662308605520000013222797345916841111_);
  fill: #3FB994;
}

.st101 {
  clip-path: url(#SVGID_00000175305453779177009010000010258946770545068989_);
}

.st102 {
  clip-path: url(#SVGID_00000054954804512452657690000017011052401174728887_);
}

.st103 {
  clip-path: url(#SVGID_00000096782095134179188240000000296278648632161471_);
  fill: #3FB994;
}

.st104 {
  clip-path: url(#SVGID_00000103259245254486738240000016447214951132830366_);
}

.st105 {
  clip-path: url(#SVGID_00000021100185348780555210000011199093575860107410_);
}

.st106 {
  clip-path: url(#SVGID_00000024696753304505578620000002680601290353093772_);
  fill: #3FB994;
}

.st107 {
  clip-path: url(#SVGID_00000118364379788902126070000016704827225041093814_);
}

.st108 {
  clip-path: url(#SVGID_00000182508960526674506030000009634554256798813858_);
}

.st109 {
  clip-path: url(#SVGID_00000114055767802519457780000009833476085814578866_);
  fill: #3FB994;
}

.st110 {
  clip-path: url(#SVGID_00000176729731318170025390000008662953097363103915_);
}

.st111 {
  clip-path: url(#SVGID_00000135661913461341206780000011013079548275159964_);
}

.st112 {
  clip-path: url(#SVGID_00000008139644754071086940000000892680545079377280_);
  fill: #3FB994;
}

.st113 {
  clip-path: url(#SVGID_00000136376048321793204440000017813487172473721508_);
}

.st114 {
  clip-path: url(#SVGID_00000060729331747925007560000005087949194949927326_);
}

.st115 {
  clip-path: url(#SVGID_00000098899807457561024030000003366041630045804950_);
  fill: #3FB994;
}

.st116 {
  clip-path: url(#SVGID_00000165955595213815874590000014117688900798425518_);
}

.st117 {
  clip-path: url(#SVGID_00000011024952658206289760000005716478847927393440_);
}

.st118 {
  clip-path: url(#SVGID_00000105420171887026696730000004277991679856222652_);
  fill: #3FB994;
}

.st119 {
  clip-path: url(#SVGID_00000044148137782136568100000002680389281447157399_);
}

.st120 {
  clip-path: url(#SVGID_00000024713989087829385530000013335228949538078356_);
}

.st121 {
  clip-path: url(#SVGID_00000092434950326819670840000013186552591264263348_);
  fill: #3FB994;
}

.st122 {
  clip-path: url(#SVGID_00000074431965373829935010000005485368811122239649_);
}

.st123 {
  clip-path: url(#SVGID_00000003817333193308185970000000676546412449253564_);
}

.st124 {
  clip-path: url(#SVGID_00000169550666000525556430000007702295177046594188_);
  fill: #3FB994;
}

.st125 {
  clip-path: url(#SVGID_00000013876520437851124860000017634520082177969827_);
}

.st126 {
  clip-path: url(#SVGID_00000136383353001678486300000016668346465081965235_);
}

.st127 {
  clip-path: url(#SVGID_00000040565143874610229830000008680878672250080678_);
  fill: #3FB994;
}

.st128 {
  clip-path: url(#SVGID_00000083076412610585376070000010672481181024188561_);
}

.st129 {
  clip-path: url(#SVGID_00000018958257032313985980000017410803369633501340_);
  fill: #154C3D;
}

.st130 {
  clip-path: url(#SVGID_00000148624538722009075130000008438346978465663627_);
}

.st131 {
  clip-path: url(#SVGID_00000148620583275284876660000015101565553921294265_);
  fill: #226A57;
}

.st132 {
  clip-path: url(#SVGID_00000181054510811933522630000003182929651577362359_);
}

.st133 {
  clip-path: url(#SVGID_00000061473754106836025710000007586731336713879443_);
  fill: #226A57;
}

.st134 {
  clip-path: url(#SVGID_00000138539498057319307730000009601707736964020882_);
}

.st135 {
  clip-path: url(#SVGID_00000129920938414723258250000008469439351175640227_);
  fill: #3FB994;
}

.st136 {
  clip-path: url(#SVGID_00000009584274769370710340000015522024867896661638_);
}

.st137 {
  clip-path: url(#SVGID_00000094583600107532219410000007332734010852408209_);
  fill: #3FB994;
}

.st138 {
  clip-path: url(#SVGID_00000036214375734534003970000015946086080257297810_);
}

.st139 {
  clip-path: url(#SVGID_00000086657251647758131810000013343001944583801003_);
  fill: #25292A;
}

.st140 {
  clip-path: url(#SVGID_00000151510545487523444880000012793418759412576900_);
}

.st141 {
  clip-path: url(#SVGID_00000168811934564020649640000003701459328143888512_);
  fill: #3FB994;
}

.st142 {
  clip-path: url(#SVGID_00000044149492476951612490000011869093142296368044_);
}

.st143 {
  clip-path: url(#SVGID_00000098213651148374627470000015710419652937710519_);
  fill: #42B994;
}

.st144 {
  clip-path: url(#SVGID_00000095306927153142757200000017197578333442835107_);
}

.st145 {
  clip-path: url(#SVGID_00000122684441764908092000000018107238328629553300_);
  fill: #25292A;
}

.st146 {
  clip-path: url(#SVGID_00000067205427988345399500000009637463699258525354_);
}

.st147 {
  clip-path: url(#SVGID_00000106122619006742066200000016032719217120045981_);
  fill: #42B994;
}

.st148 {
  clip-path: url(#SVGID_00000036959597910572173960000009662831669575730599_);
}

.st149 {
  clip-path: url(#SVGID_00000077312468666040161480000014176925847104357816_);
  fill: #25292A;
}

.st150 {
  clip-path: url(#SVGID_00000183241756489887450490000013066212811338164157_);
}

.st151 {
  clip-path: url(#SVGID_00000030483713095154813620000012295576417963072386_);
  fill: #42B994;
}

.st152 {
  clip-path: url(#SVGID_00000168803389542685532700000011249896345466032019_);
}

.st153 {
  clip-path: url(#SVGID_00000039838263920084817960000004918564646638246047_);
  fill: #25292A;
}

.st154 {
  clip-path: url(#SVGID_00000084526094262751281740000002586762244981045908_);
}

.st155 {
  clip-path: url(#SVGID_00000090996699882544030470000015439841284908389508_);
  enable-background: new;
}

.st156 {
  clip-path: url(#SVGID_00000084516938466372943070000018400865617271180462_);
}

.st157 {
  clip-path: url(#SVGID_00000150823153774206236710000017953103993566349477_);
}

.st158 {
  clip-path: url(#SVGID_00000081635125599491860640000009245812868157255611_);
  fill: #25292A;
}

.st159 {
  clip-path: url(#SVGID_00000156560699078303207340000010556231915390109363_);
}

.st160 {
  clip-path: url(#SVGID_00000145016700044530255610000013957340528374354340_);
}

.st161 {
  clip-path: url(#SVGID_00000121977688842457805890000003907299254438182037_);
  fill: #25292A;
}

.st162 {
  clip-path: url(#SVGID_00000137840798807270775210000005993734953143728267_);
}

.st163 {
  clip-path: url(#SVGID_00000171684301887955835500000006068198180861814695_);
  enable-background: new;
}

.st164 {
  clip-path: url(#SVGID_00000008828161189455097680000012087829078049253261_);
}

.st165 {
  clip-path: url(#SVGID_00000021814945558922326090000015031565279881074110_);
}

.st166 {
  clip-path: url(#SVGID_00000031922107164964349320000004448318049162151054_);
  fill: #3FB994;
}

.st167 {
  clip-path: url(#SVGID_00000083086575867122328750000000880478529725520034_);
}

.st168 {
  clip-path: url(#SVGID_00000026884169247951974690000008985701864279914673_);
}

.st169 {
  clip-path: url(#SVGID_00000094590667905546076040000006701603090996896956_);
  fill: #001820;
}

.st170 {
  clip-path: url(#SVGID_00000121967951290033570980000006438586022048011921_);
}

.st171 {
  clip-path: url(#SVGID_00000066512183410393745360000004139386092860337808_);
  fill: #25292A;
}

.st172 {
  clip-path: url(#SVGID_00000079480609012668466880000001785787826380360622_);
}

.st173 {
  clip-path: url(#SVGID_00000013898536736138225910000011360711050588748204_);
  fill: #25292A;
}

.st174 {
  clip-path: url(#SVGID_00000095302181846677196370000004375941094415533497_);
}

.st175 {
  clip-path: url(#SVGID_00000042719842051250442610000016280178559793665423_);
  fill: #A4A6A5;
}

.st176 {
  clip-path: url(#SVGID_00000038415427191477747360000013637874766869755324_);
}

.st177 {
  clip-path: url(#SVGID_00000173855641852338018150000005870154846280441265_);
  fill: #9CB3C6;
}

.st178 {
  clip-path: url(#SVGID_00000017507173391573643020000016895500537653662130_);
}

.st179 {
  clip-path: url(#SVGID_00000052800144921367788380000000313017313489938857_);
  fill: #9CB3C6;
}

.st180 {
  clip-path: url(#SVGID_00000105406581359931349240000016226232509747120306_);
}

.st181 {
  clip-path: url(#SVGID_00000116954904078463430830000000707710087531206037_);
  fill: #25292A;
}

.st182 {
  clip-path: url(#SVGID_00000088115988930947741190000015072912755770196609_);
}

.st183 {
  clip-path: url(#SVGID_00000173152899925300667730000001856445641973816248_);
  fill: #E0E1DB;
}

.st184 {
  clip-path: url(#SVGID_00000147899609886645864410000018026745761679041432_);
}

.st185 {
  clip-path: url(#SVGID_00000081634250438556757220000007249334492128619447_);
  fill: #25292A;
}

.st186 {
  clip-path: url(#SVGID_00000174567751103804703790000013272209045937953459_);
}

.st187 {
  clip-path: url(#SVGID_00000134939396759763889240000003070713926085084036_);
  fill: #25292A;
}

.st188 {
  clip-path: url(#SVGID_00000002355956582503962880000011038534681854801312_);
}

.st189 {
  clip-path: url(#SVGID_00000121973155670307480900000016560887111550714777_);
  fill: #25292A;
}

.st190 {
  clip-path: url(#SVGID_00000075882497821608727130000007270139120504755865_);
}

.st191 {
  clip-path: url(#SVGID_00000163042330237493866340000008869664092065895326_);
  fill: #A4A6A5;
}

.st192 {
  clip-path: url(#SVGID_00000086657007158272740640000004966028056223314056_);
}

.st193 {
  clip-path: url(#SVGID_00000013914627852998444640000011410468245717026973_);
  enable-background: new;
}

.st194 {
  clip-path: url(#SVGID_00000142854536655146654170000010919731907304803713_);
}

.st195 {
  clip-path: url(#SVGID_00000174594647613422791110000016624349689238024850_);
}

.st196 {
  opacity: 0;
  clip-path: url(#SVGID_00000046310846965209202360000017180640208340531349_);
}

.st197 {
  clip-path: url(#SVGID_00000162350029314558655300000015103007664443927197_);
}

.st198 {
  clip-path: url(#SVGID_00000162354082975291470160000000742461152629527221_);
}

.st199 {
  clip-path: url(#SVGID_00000116950385688058117210000014668175670119519631_);
  enable-background: new;
}

.st200 {
  clip-path: url(#SVGID_00000075852716039977284770000016181256145894724255_);
}

.st201 {
  clip-path: url(#SVGID_00000160871395217676516280000016710925594901062571_);
}

.st202 {
  opacity: 0;
  clip-path: url(#SVGID_00000027600070240581410760000000681733360423177867_);
}

.st203 {
  clip-path: url(#SVGID_00000016076569816525992470000006989835514618858938_);
}

.st204 {
  clip-path: url(#SVGID_00000179618045522052490750000007566141083275060867_);
}

.st205 {
  clip-path: url(#SVGID_00000070807162594931486180000012660811671365942206_);
  enable-background: new;
}

.st206 {
  clip-path: url(#SVGID_00000011026212525749524740000009339788006584212117_);
}

.st207 {
  clip-path: url(#SVGID_00000017490321785671505810000000274403636788401852_);
}

.st208 {
  opacity: 0;
  clip-path: url(#SVGID_00000124152963388627738240000001295039031217200815_);
}

.st209 {
  clip-path: url(#SVGID_00000181044953308722361300000011222300461383994777_);
}

.st210 {
  clip-path: url(#SVGID_00000029027132381205856080000002397978662137492626_);
}

.st211 {
  clip-path: url(#SVGID_00000067210187939163272450000005027459758670632635_);
  fill: #4EBD99;
}

.st212 {
  clip-path: url(#SVGID_00000098921725335000355800000013118012781995186070_);
}

.st213 {
  clip-path: url(#SVGID_00000046300814054686568880000016230703886434544286_);
  fill: #42B994;
}

.st214 {
  clip-path: url(#SVGID_00000052820130761228945390000013761950354762056845_);
}

.st215 {
  clip-path: url(#SVGID_00000089571549767977615930000009711483920171752354_);
  fill: #226A57;
}

.st216 {
  clip-path: url(#SVGID_00000095312191280290992710000014899919716047403906_);
}

.st217 {
  clip-path: url(#SVGID_00000031184818224599426990000018085895651151591825_);
  fill: #165748;
}

.st218 {
  clip-path: url(#SVGID_00000038391187286352032120000017042764339010140049_);
}

.st219 {
  clip-path: url(#SVGID_00000155104916553689804510000018012108211062677677_);
  fill: #42B994;
}

.st220 {
  clip-path: url(#SVGID_00000026140526264774085610000003816840818268181168_);
}

.st221 {
  clip-path: url(#SVGID_00000172414240139721470150000004908977419062461319_);
  fill: #226A57;
}

.st222 {
  clip-path: url(#SVGID_00000013182895695497211820000014415178529628306605_);
}

.st223 {
  clip-path: url(#SVGID_00000080177537718850351070000008471425060065155206_);
  fill: #165748;
}

.st224 {
  clip-path: url(#SVGID_00000118387643707936775060000010883333527379036340_);
}

.st225 {
  clip-path: url(#SVGID_00000124123707074933486540000003190014274977673355_);
  fill: #42B994;
}

.st226 {
  clip-path: url(#SVGID_00000119112788521157172220000002984391480331933065_);
}

.st227 {
  clip-path: url(#SVGID_00000111172438127232865320000015358262805944261550_);
  fill: #226A57;
}

.st228 {
  clip-path: url(#SVGID_00000114062325586581374340000012666241138150766224_);
}

.st229 {
  clip-path: url(#SVGID_00000090980176127264050810000002883289645941070261_);
  fill: #165748;
}

.st230 {
  clip-path: url(#SVGID_00000115513523436727121400000008981876108481078422_);
}

.st231 {
  clip-path: url(#SVGID_00000153694071356525330080000010656926448393055124_);
  fill: #42B994;
}

.st232 {
  clip-path: url(#SVGID_00000132805623353540829990000007244108085085438597_);
}

.st233 {
  clip-path: url(#SVGID_00000116200782864583535040000010927434178842159748_);
  fill: #226A57;
}

.st234 {
  clip-path: url(#SVGID_00000101821486799610751680000003222828967699062676_);
}

.st235 {
  clip-path: url(#SVGID_00000007424257550961084100000014873771528114031274_);
  fill: #165748;
}

.st236 {
  clip-path: url(#SVGID_00000038379713425909603740000003309454308827356045_);
}

.st237 {
  clip-path: url(#SVGID_00000132767952632618085220000012187723749618852225_);
  fill: #42B994;
}

.st238 {
  clip-path: url(#SVGID_00000147204802194886504460000014509572090913701562_);
}

.st239 {
  clip-path: url(#SVGID_00000093178775137637206420000012347403105276488616_);
  fill: #226A57;
}

.st240 {
  clip-path: url(#SVGID_00000174603694043226993550000007072003757241891206_);
}

.st241 {
  clip-path: url(#SVGID_00000074416609104867417210000014767422384089842820_);
  fill: #165748;
}

.st242 {
  clip-path: url(#SVGID_00000083086033184057210810000017885607745054161568_);
}

.st243 {
  clip-path: url(#SVGID_00000000220868713302708280000014413309976392951482_);
  fill: #226A57;
}

.st244 {
  clip-path: url(#SVGID_00000081632643293406355340000014660184090500179900_);
}

.st245 {
  clip-path: url(#SVGID_00000059299297573722585590000011279241776330398895_);
  fill: #FFFFFF;
}

.st246 {
  clip-path: url(#SVGID_00000026122067503383849430000009140021654797687450_);
}

.st247 {
  clip-path: url(#SVGID_00000075125120790941444980000009486801264389095086_);
  fill: #226A57;
}

.st248 {
  clip-path: url(#SVGID_00000076603076872699696770000009645107429490664109_);
}

.st249 {
  clip-path: url(#SVGID_00000028307240869596189920000000220005363644296326_);
  fill: #42B994;
}

.st250 {
  clip-path: url(#SVGID_00000098183199498119195370000013545896708014090169_);
}

.st251 {
  clip-path: url(#SVGID_00000137839757246282625560000000245620567368031915_);
  fill: #226A57;
}

.st252 {
  clip-path: url(#SVGID_00000005252237678703115020000003180203124149544882_);
}

.st253 {
  clip-path: url(#SVGID_00000051385352120322002430000018265414011583602607_);
  fill: #42B994;
}

.st254 {
  clip-path: url(#SVGID_00000178186400365246774350000011269496349599039159_);
}

.st255 {
  clip-path: url(#SVGID_00000014607241415861829280000002034654290012895649_);
  fill: #226A57;
}

.st256 {
  clip-path: url(#SVGID_00000131339505572345478970000009591852831847311018_);
}

.st257 {
  clip-path: url(#SVGID_00000017507186650105291070000011092441295466630789_);
  fill: #42B994;
}

.st258 {
  clip-path: url(#SVGID_00000124144590441635090200000017883327788189692301_);
}

.st259 {
  clip-path: url(#SVGID_00000045584535924918082290000015975313336074656693_);
  fill: #EBEAE6;
}

.st260 {
  clip-path: url(#SVGID_00000025421850887240735410000014366104077340118676_);
}

.st261 {
  clip-path: url(#SVGID_00000007400677765228751970000009687123376945561477_);
  fill: #DCDDD7;
}

.st262 {
  clip-path: url(#SVGID_00000158016797890287732970000009359117728290878377_);
}

.st263 {
  clip-path: url(#SVGID_00000074426155111516569450000001129807951634201534_);
  fill: #868B89;
}

.st264 {
  clip-path: url(#SVGID_00000157309095318744931230000017841618466479151262_);
}

.st265 {
  clip-path: url(#SVGID_00000047758703576526016040000002280537005906852736_);
  fill: #95CCB9;
}

.st266 {
  clip-path: url(#SVGID_00000029004640665488908630000017389091502393093787_);
}

.st267 {
  clip-path: url(#SVGID_00000043436962322793694200000016085213816661941653_);
  fill: #82A79C;
}

.st268 {
  clip-path: url(#SVGID_00000148644519581130462020000003685877012360420795_);
}

.st269 {
  clip-path: url(#SVGID_00000176749910056131226920000003067158936504868236_);
  fill: #7FA096;
}

.st270 {
  clip-path: url(#SVGID_00000079477952805873789950000001221522455920064419_);
}

.st271 {
  clip-path: url(#SVGID_00000044889406590058771410000005174224031770263176_);
  fill: #95CCB9;
}

.st272 {
  clip-path: url(#SVGID_00000094583830532839496410000004456230915270799038_);
}

.st273 {
  clip-path: url(#SVGID_00000014613034242780401940000007431534073827870135_);
  fill: #82A79C;
}

.st274 {
  clip-path: url(#SVGID_00000046306542487264261490000002105582811905706410_);
}

.st275 {
  clip-path: url(#SVGID_00000175285963088128633540000002332604300429151395_);
  fill: #7FA096;
}

.st276 {
  clip-path: url(#SVGID_00000122708717323811913880000014690878960047565206_);
}

.st277 {
  clip-path: url(#SVGID_00000172415439874234867700000001789248057657419669_);
  fill: #95CCB9;
}

.st278 {
  clip-path: url(#SVGID_00000143612722046889342730000014418296729267847097_);
}

.st279 {
  clip-path: url(#SVGID_00000100354246690568891280000013741654664313981339_);
  fill: #82A79C;
}

.st280 {
  clip-path: url(#SVGID_00000175302062749796151250000004605327765772262033_);
}

.st281 {
  clip-path: url(#SVGID_00000142887680347311552190000001863356338153281417_);
  fill: #95CCB9;
}

.st282 {
  clip-path: url(#SVGID_00000176037167146950795490000001896533934107714963_);
}

.st283 {
  clip-path: url(#SVGID_00000165193728660430260660000000317039956677573294_);
  fill: #82A79C;
}

.st284 {
  clip-path: url(#SVGID_00000035488400593482639060000004869732968319713946_);
}

.st285 {
  clip-path: url(#SVGID_00000060747285053927876870000013944414184041703095_);
  fill: #7FA096;
}

.st286 {
  clip-path: url(#SVGID_00000150085424085253749110000009589715178434803882_);
}

.st287 {
  clip-path: url(#SVGID_00000008858831604965600170000007776039860728457863_);
  fill: #95CCB9;
}

.st288 {
  clip-path: url(#SVGID_00000081625194233365610710000012814527117300998814_);
}

.st289 {
  clip-path: url(#SVGID_00000079486792530777540320000016616890179924538539_);
  fill: #7FA096;
}

.st290 {
  clip-path: url(#SVGID_00000026164669397829802140000003441112498677636532_);
}

.st291 {
  clip-path: url(#SVGID_00000140704132679443191010000014353393584581093028_);
  fill: #82A79C;
}

.st292 {
  clip-path: url(#SVGID_00000165942766853571279230000008211260459420491944_);
}

.st293 {
  clip-path: url(#SVGID_00000179603805354195348880000009732410819008730020_);
  fill: #EBEBE7;
}

.st294 {
  clip-path: url(#SVGID_00000119084293243895492030000014809150399221388693_);
}

.st295 {
  clip-path: url(#SVGID_00000159427876311386444570000015185434991413019015_);
  fill: #999A98;
}

.st296 {
  clip-path: url(#SVGID_00000142879990606584618150000000974601015515835012_);
}

.st297 {
  clip-path: url(#SVGID_00000083054762032855497960000005556122904600070018_);
  fill: #999A98;
}

.st298 {
  clip-path: url(#SVGID_00000011024073813197856490000002386602748967518120_);
}

.st299 {
  clip-path: url(#SVGID_00000087398024882319936090000015389056893313158320_);
  fill: #6B59A6;
}

.st300 {
  clip-path: url(#SVGID_00000032627472030073089130000006541097060016316081_);
}

.st301 {
  clip-path: url(#SVGID_00000066476951465516739330000009734194063945677718_);
  fill: #6B59A6;
}

.st302 {
  clip-path: url(#SVGID_00000102529069497923055890000008952220312774117542_);
}

.st303 {
  clip-path: url(#SVGID_00000043436267505883346920000016179845358106196159_);
  fill: #548D7A;
}

.st304 {
  clip-path: url(#SVGID_00000181059155625145943090000018232481533879565217_);
}

.st305 {
  clip-path: url(#SVGID_00000150823446535522110850000002096106114818309787_);
  fill: #4D8271;
}

.st306 {
  clip-path: url(#SVGID_00000183943929636040223300000008738241660943570091_);
}

.st307 {
  clip-path: url(#SVGID_00000100365645294671692370000002870084250014787486_);
  fill: #4A7F6F;
}

.st308 {
  clip-path: url(#SVGID_00000028315918693969898180000007756272644872153265_);
}

.st309 {
  clip-path: url(#SVGID_00000057851703563303594900000002150778774735551917_);
  fill: #4D8271;
}

.st310 {
  clip-path: url(#SVGID_00000005968025613825345900000011809042888896314509_);
}

.st311 {
  clip-path: url(#SVGID_00000031184186542104628130000007406523142119493039_);
  fill: #699687;
}

.st312 {
  clip-path: url(#SVGID_00000049934005646534423390000014228978317318779780_);
}

.st313 {
  clip-path: url(#SVGID_00000168086728199959681070000004854635483826152580_);
  fill: #C9DAD1;
}

.st314 {
  clip-path: url(#SVGID_00000160152559376099155100000005939980908240425634_);
}

.st315 {
  clip-path: url(#SVGID_00000164479171034975158650000013056230111081603235_);
  fill: #C9DAD1;
}

.st316 {
  clip-path: url(#SVGID_00000098206824697642738740000017555751550786187939_);
}

.st317 {
  clip-path: url(#SVGID_00000043417403962390204650000016358848312618514591_);
  fill: #C9DAD1;
}

.st318 {
  clip-path: url(#SVGID_00000034799925904781467880000013145530926054577553_);
}

.st319 {
  clip-path: url(#SVGID_00000000199324504631530200000018311733368740394630_);
  fill: #165748;
}

.st320 {
  clip-path: url(#SVGID_00000038375555228855153010000014441764677435881909_);
}

.st321 {
  clip-path: url(#SVGID_00000140700858215516930360000009083389485825303957_);
  fill: #165748;
}

.st322 {
  clip-path: url(#SVGID_00000001631805743121941300000015722698328296700295_);
}

.st323 {
  clip-path: url(#SVGID_00000072963292456375619050000000331412559354150581_);
  fill: #165748;
}

.st324 {
  clip-path: url(#SVGID_00000053546634736151450200000018351534601107989634_);
}

.st325 {
  clip-path: url(#SVGID_00000137855065464142655250000001314137718536327862_);
  fill: #165748;
}

.st326 {
  clip-path: url(#SVGID_00000029757042137915581590000014926566451587789214_);
}

.st327 {
  clip-path: url(#SVGID_00000103260635818720057940000004058615816228734853_);
  fill: #A4B6AD;
}

.st328 {
  clip-path: url(#SVGID_00000042715189129304576080000008398995650082481320_);
}

.st329 {
  clip-path: url(#SVGID_00000160903123850478153290000013194618081122087608_);
  fill: #A2B3AB;
}

.st330 {
  clip-path: url(#SVGID_00000025424799509724703950000003185093316461769618_);
}

.st331 {
  clip-path: url(#SVGID_00000110451969476623003390000002169675482061768087_);
  fill: #91B1A5;
}

.st332 {
  clip-path: url(#SVGID_00000011011856926805647290000011944177034360798384_);
}

.st333 {
  clip-path: url(#SVGID_00000041975795448573600670000013504971048052586117_);
  fill: #8BA79D;
}

.st334 {
  clip-path: url(#SVGID_00000014598522257531685780000018073917052759760287_);
}

.st335 {
  clip-path: url(#SVGID_00000183929199329507128530000014234818204225070492_);
  fill: #91B1A5;
}

.st336 {
  clip-path: url(#SVGID_00000129200734825831076050000013472431420604667293_);
}

.st337 {
  clip-path: url(#SVGID_00000064337636496428873730000017925099680459243680_);
  fill: #8BA79D;
}

.st338 {
  clip-path: url(#SVGID_00000118357952215815222750000006974174850119573172_);
}

.st339 {
  clip-path: url(#SVGID_00000043437959745818789020000016510722790592962954_);
  fill: #6E9084;
}

.st340 {
  clip-path: url(#SVGID_00000084493082790778678010000006606521788914333095_);
}

.st341 {
  clip-path: url(#SVGID_00000165926136443612147490000015351161526144378547_);
  fill: #165748;
}

.st342 {
  clip-path: url(#SVGID_00000125604355055703484530000001627225902901375379_);
}

.st343 {
  clip-path: url(#SVGID_00000068640889120494524230000007462686082020482745_);
  fill: #165748;
}

.st344 {
  clip-path: url(#SVGID_00000119817018042653011960000004681385376445907098_);
}

.st345 {
  clip-path: url(#SVGID_00000155124248821808992670000010807902597540762781_);
  fill: #EBEAE6;
}

.st346 {
  clip-path: url(#SVGID_00000109030168037710706290000011458523491065337219_);
}

.st347 {
  clip-path: url(#SVGID_00000116202783138868719420000017151187704542798218_);
  fill: #DCDDD7;
}

.st348 {
  clip-path: url(#SVGID_00000005971413210245440900000012274277991928640153_);
}

.st349 {
  clip-path: url(#SVGID_00000086653830586535924570000015424352186640014527_);
  fill: #868B89;
}

.st350 {
  clip-path: url(#SVGID_00000090263742179380019150000017910952260625775275_);
}

.st351 {
  clip-path: url(#SVGID_00000146478057681031786490000009797715338314665600_);
  fill: #DCDDD7;
}

.st352 {
  clip-path: url(#SVGID_00000129911984261913444180000000845941969023667386_);
}

.st353 {
  clip-path: url(#SVGID_00000105386277668457639070000005877430791985345188_);
  fill: #999C9A;
}

.st354 {
  clip-path: url(#SVGID_00000161616489139238783780000003534502913373698746_);
}

.st355 {
  clip-path: url(#SVGID_00000086653579083328409600000014109761122214708884_);
  fill: #999C9A;
}

.st356 {
  clip-path: url(#SVGID_00000129908845133096483210000005147055030299724692_);
}

.st357 {
  clip-path: url(#SVGID_00000036944961405805591780000009895069865065575588_);
  fill: #98CAB7;
}

.st358 {
  clip-path: url(#SVGID_00000129890937778265361170000011179491507032130475_);
}

.st359 {
  clip-path: url(#SVGID_00000165205857197802818330000014622752624221956257_);
  fill: #6E9A8A;
}

.st360 {
  clip-path: url(#SVGID_00000164486826699100196660000009505025102305708206_);
}

.st361 {
  clip-path: url(#SVGID_00000114054694794519334860000001244442457086300863_);
  fill: #6B59A6;
}

.st362 {
  clip-path: url(#SVGID_00000178197625346316854820000007532493464714826420_);
}

.st363 {
  clip-path: url(#SVGID_00000036218369443146478510000013229628686232670872_);
  fill: #699085;
}

.st364 {
  clip-path: url(#SVGID_00000013152200899479469920000002920279472163280041_);
}

.st365 {
  clip-path: url(#SVGID_00000028316229771434837080000000712102017693518234_);
  fill: #98CAB7;
}

.st366 {
  clip-path: url(#SVGID_00000049182149792800705930000012104894882556250013_);
}

.st367 {
  clip-path: url(#SVGID_00000152247357937822834180000014533128999066576005_);
  fill: #679384;
}

.st368 {
  clip-path: url(#SVGID_00000029753107784477999730000005214032695220307621_);
}

.st369 {
  clip-path: url(#SVGID_00000040552490523484253900000014274339065630729353_);
  fill: #6B59A6;
}

.st370 {
  clip-path: url(#SVGID_00000085210758512392431850000017115129325965122706_);
}

.st371 {
  clip-path: url(#SVGID_00000147912394512193970070000013177401494110800291_);
  fill: #6B59A6;
}

.st372 {
  clip-path: url(#SVGID_00000085941509622661891570000003567614153647525011_);
}

.st373 {
  clip-path: url(#SVGID_00000130614954336207672300000015219120534302289073_);
  fill: #6B59A6;
}

.st374 {
  clip-path: url(#SVGID_00000008868002983396951340000015300621572246534042_);
}

.st375 {
  clip-path: url(#SVGID_00000042712617327510262310000001265861663652895642_);
  fill: #6B59A6;
}

.st376 {
  clip-path: url(#SVGID_00000078737645641916711420000007814152044621734037_);
}

.st377 {
  clip-path: url(#SVGID_00000074410445829287484690000004047651276536546442_);
  fill: #547E6F;
}

.st378 {
  clip-path: url(#SVGID_00000042736418108686614640000001011655495489691042_);
}

.st379 {
  clip-path: url(#SVGID_00000055688981192376315870000000401823210840027818_);
  fill: #C7D9D0;
}

.st380 {
  clip-path: url(#SVGID_00000150809763808322555390000008398658368318339001_);
}

.st381 {
  clip-path: url(#SVGID_00000084498295516705984440000001308670848766486461_);
  fill: #C7D9D0;
}

.st382 {
  clip-path: url(#SVGID_00000080894527157528363570000015285551706927633283_);
}

.st383 {
  clip-path: url(#SVGID_00000023971846261312459270000013822657573546156473_);
  fill: #C7D9D0;
}

.st384 {
  fill: #E0E1DB;
}

.st385 {
  clip-path: url(#SVGID_00000072238082242463718140000007932344180660812721_);
}

.st386 {
  clip-path: url(#SVGID_00000124876186245520976780000004374664798644725935_);
  enable-background: new;
}

.st387 {
  clip-path: url(#SVGID_00000127738149939780238830000015553823054673981093_);
}

.st388 {
  clip-path: url(#SVGID_00000155122937346458628340000006137570393328685977_);
}

.st389 {
  opacity: 0;
  clip-path: url(#SVGID_00000011748496255613195040000008811691154356767886_);
}

.st390 {
  clip-path: url(#SVGID_00000174572516742158663650000008126704403204404361_);
}

.st391 {
  clip-path: url(#SVGID_00000129910020555987714560000004957837752808919739_);
}

.st392 {
  clip-path: url(#SVGID_00000155847722210879238370000003326604335042424455_);
  fill: #6B59A6;
}

.st393 {
  clip-path: url(#SVGID_00000051353359433367542730000014135902448642311309_);
}

.st394 {
  clip-path: url(#SVGID_00000008855467025375423300000007207834421656857763_);
  enable-background: new;
}

.st395 {
  clip-path: url(#SVGID_00000180339817893050865930000004796793478397638797_);
}

.st396 {
  clip-path: url(#SVGID_00000124873653301523425950000015145659041106311048_);
}

.st397 {
  opacity: 0;
  clip-path: url(#SVGID_00000103948297342656569190000006226727291529671340_);
}

.st398 {
  clip-path: url(#SVGID_00000128476777582049843460000006779836454374838192_);
}

.st399 {
  clip-path: url(#SVGID_00000183232581063831497000000002466532454833965974_);
}

.st400 {
  clip-path: url(#SVGID_00000079467357359441134790000000871338613183581851_);
  fill: #3E3F6F;
}

.st401 {
  opacity: 0.1;
}

.st402 {
  fill: #1F715C;
}

.st403 {
  fill: #A5B5BB;
}

.st404 {
  fill: #49BD99;
}

.st405 {
  fill: #2A2C2F;
}

.st406 {
  fill: #FFFFFF;
}

.st407 {
  fill: #434648;
}

.st408 {
  fill: #231F20;
}

.st409 {
  fill: #14604E;
}

.st410 {
  opacity: 0.8;
  fill: #2A2C2F;
}

.st411 {
  fill: #79AA9D;
}

.st412 {
  fill: url(#SVGID_00000080188057502523621700000001891381432332287638_);
}

.st413 {
  fill: #AFB4C4;
}

.st414 {
  fill: url(#SVGID_00000057826982219519993020000002949633381544068275_);
}

.st415 {
  fill: #EEF0F5;
}

.st416 {
  fill: #C8CEDB;
}

.st417 {
  enable-background: new;
}

.st418 {
  clip-path: url(#SVGID_00000132047534602745360250000013132742037329040266_);
  enable-background: new;
}

.st419 {
  fill: #0D3F33;
}

.st420 {
  clip-path: url(#SVGID_00000116935100242728187450000005678938123797641362_);
  enable-background: new;
}

.st421 {
  fill: #0A3229;
}

.st422 {
  fill: #115444;
}

.st423 {
  fill: #0A3027;
}

.st424 {
  clip-path: url(#SVGID_00000078729876114706872770000009701101783834356637_);
  enable-background: new;
}

.st425 {
  fill: #0C3A2F;
}

.st426 {
  fill: #0C3C30;
}

.st427 {
  fill: #0D3D32;
}

.st428 {
  fill: #0C382D;
}

.st429 {
  fill: #0B362C;
}

.st430 {
  fill: #0B342A;
}

.st431 {
  opacity: 0.7;
}

.st432 {
  clip-path: url(#SVGID_00000135693032969732711280000005101442561876424104_);
  enable-background: new;
}

.st433 {
  fill: #608E80;
}

.st434 {
  clip-path: url(#SVGID_00000042721965734894772910000010634508059927507085_);
  enable-background: new;
}

.st435 {
  fill: #588174;
}

.st436 {
  fill: #5B8578;
}

.st437 {
  fill: #5D8A7C;
}

.st438 {
  clip-path: url(#SVGID_00000032648467908781121430000007620939110594544318_);
  enable-background: new;
}

.st439 {
  fill: #557D71;
}

.st440 {
  fill: #52786D;
}

.st441 {
  fill: #4F7469;
}

.st442 {
  fill: #4C7065;
}

.st443 {
  clip-path: url(#SVGID_00000095317694553783866720000017407420127120400027_);
  enable-background: new;
}

.st444 {
  clip-path: url(#SVGID_00000033362082787178877300000017503755972542683568_);
  enable-background: new;
}

.st445 {
  clip-path: url(#SVGID_00000169532845702369906930000001951098489992364449_);
  enable-background: new;
}

.st446 {
  clip-path: url(#SVGID_00000122688515468310093330000003428499860828569501_);
  enable-background: new;
}

.st447 {
  clip-path: url(#SVGID_00000147941703026615033660000007670783243247485348_);
  enable-background: new;
}

.st448 {
  clip-path: url(#SVGID_00000129185147453225678850000007664091518001965711_);
  enable-background: new;
}

.st449 {
  clip-path: url(#SVGID_00000181083184630986417540000017648831758855131297_);
  enable-background: new;
}

.st450 {
  fill: #7FBCA9;
}

.st451 {
  clip-path: url(#SVGID_00000052084223666525811480000005175290479485096894_);
  enable-background: new;
}

.st452 {
  fill: #496C61;
}

.st453 {
  fill: #255F4D;
}

.st454 {
  clip-path: url(#SVGID_00000167395502821239621160000014156815994686609323_);
  enable-background: new;
}

.st455 {
  fill: #307D65;
}

.st456 {
  fill: #2F7962;
}

.st457 {
  fill: #2D755F;
}

.st458 {
  clip-path: url(#SVGID_00000073686403485396605360000005137340884282061449_);
  enable-background: new;
}

.st459 {
  fill: #266250;
}

.st460 {
  fill: #276653;
}

.st461 {
  fill: #296A56;
}

.st462 {
  fill: #2A6E59;
}

.st463 {
  fill: #2C715C;
}

.st464 {
  fill: #40A586;
}

.st465 {
  clip-path: url(#SVGID_00000128454696802042121940000010154821945726151303_);
  enable-background: new;
}

.st466 {
  clip-path: url(#SVGID_00000028294360555198607500000005409093801452336285_);
  enable-background: new;
}

.st467 {
  clip-path: url(#SVGID_00000134962112555771363220000015023143216625987467_);
  enable-background: new;
}

.st468 {
  clip-path: url(#SVGID_00000060724896959576870660000005611089080281222064_);
  enable-background: new;
}

.st469 {
  clip-path: url(#SVGID_00000044877283889649479910000015773142531570366098_);
  enable-background: new;
}

.st470 {
  clip-path: url(#SVGID_00000158010428860706982990000000205385562710739081_);
  enable-background: new;
}

.st471 {
  clip-path: url(#SVGID_00000016060187729143145630000003127921237397771927_);
  enable-background: new;
}

.st472 {
  clip-path: url(#SVGID_00000072252876264646370650000001901023339233339304_);
  enable-background: new;
}

.st473 {
  clip-path: url(#SVGID_00000043434056986553876580000015254751384702700431_);
  enable-background: new;
}

.st474 {
  clip-path: url(#SVGID_00000119803198845989964840000000560950993125275066_);
  enable-background: new;
}

.st475 {
  fill: #33836A;
}

.st476 {
  fill: url(#SVGID_00000155147125657188871430000014114143459004973503_);
}

.st477 {
  fill: url(#SVGID_00000126307721447469789470000007287766073494549923_);
}

.st478 {
  fill: url(#SVGID_00000165944824020244123040000008830581737496892560_);
}

.st479 {
  fill: url(#SVGID_00000021809887298746247150000004053543640450053014_);
}

.st480 {
  fill: url(#SVGID_00000055706588211977981370000003750853909840497832_);
}

.st481 {
  fill: url(#SVGID_00000156575639962263168100000005138824080111419522_);
}

.st482 {
  fill: url(#SVGID_00000085957352746996755920000008438619163933279630_);
}

.st483 {
  fill: url(#SVGID_00000085210940913422973210000014045295120820121005_);
}

.st484 {
  fill: url(#SVGID_00000038412127745620893930000001656920839645979301_);
}

.st485 {
  fill: url(#SVGID_00000053544397264085078600000014323984065270215834_);
}

.st486 {
  fill: url(#SVGID_00000142166639004121487240000007845981878794756277_);
}

.st487 {
  fill: url(#SVGID_00000016072364742882130780000008867475059885960333_);
}

.st488 {
  fill: url(#SVGID_00000072271392471594991830000016655523857756479418_);
}

.st489 {
  fill: url(#SVGID_00000130621967673079958160000000261302994431749523_);
}

.st490 {
  fill: url(#SVGID_00000158714517631576318980000010998353326722309793_);
}

.st491 {
  fill: url(#SVGID_00000036973628741798879480000016852598269671746199_);
}

.st492 {
  fill: url(#SVGID_00000094588192548635256420000007949165626442024084_);
}

.st493 {
  fill: url(#SVGID_00000159432884393409754310000001638569466321499282_);
}

.st494 {
  fill: url(#SVGID_00000140001186201940167710000016626991863207728038_);
}

.st495 {
  fill: url(#SVGID_00000163778586418708976230000002674203881072573116_);
}

.st496 {
  fill: url(#SVGID_00000000219281419857940590000001650170603697417621_);
}

.st497 {
  fill: url(#SVGID_00000137824461822830986350000010874667238981768891_);
}

.st498 {
  fill: url(#SVGID_00000125566577493016310810000008355371513055625637_);
}

.st499 {
  fill: url(#SVGID_00000122679117696563770100000001416057875051643035_);
}

.st500 {
  fill: url(#SVGID_00000026855010386600353880000016426346571486923171_);
}

.st501 {
  fill: url(#SVGID_00000145752592124110189670000010545828448060945835_);
}

.st502 {
  fill: url(#SVGID_00000137119495448228808550000002849193332966325928_);
}

.st503 {
  fill: url(#SVGID_00000126288442850355019080000010340971667627224243_);
}

.st504 {
  fill: url(#SVGID_00000117637278969635053280000008858171494462159545_);
}

.st505 {
  fill: url(#SVGID_00000008865157626834424870000008969974964032387978_);
}

.st506 {
  fill: url(#SVGID_00000137835791715663991960000014178319542155837095_);
}

.st507 {
  fill: url(#SVGID_00000169548821256832535450000005721308700882169253_);
}

.st508 {
  fill: url(#SVGID_00000181794674691243090670000001505541024799682736_);
}

.st509 {
  fill: url(#SVGID_00000029731316846007076140000009860988380808495762_);
}

.st510 {
  fill: url(#SVGID_00000075842740060094864720000016907823396098971276_);
}

.st511 {
  fill: url(#SVGID_00000152264492680846068630000011318727256880602248_);
}

.st512 {
  fill: url(#SVGID_00000183239852877321290240000004752902431548492203_);
}

.st513 {
  fill: url(#SVGID_00000133515235492936631320000016510248145100442815_);
}

.st514 {
  fill: url(#SVGID_00000127743759864556862740000005041104230469307053_);
}

.st515 {
  fill: url(#SVGID_00000145048600766142059140000012836094967352020610_);
}

.st516 {
  fill: url(#SVGID_00000110431696799222011160000002344324344852113321_);
}

.st517 {
  fill: url(#SVGID_00000121280848531781897320000015274744421691463855_);
}

.st518 {
  fill: url(#SVGID_00000040532517462976378480000013690570625170469776_);
}

.st519 {
  fill: url(#SVGID_00000119108958518940165400000017552527587779314053_);
}

.st520 {
  fill: url(#SVGID_00000006669202464701188670000004111602662411872925_);
}

.st521 {
  fill: url(#SVGID_00000181063909807804693610000000605784362568284059_);
}

.st522 {
  fill: url(#SVGID_00000165928758205548093140000017523971309535968397_);
}

.st523 {
  fill: url(#SVGID_00000040553422013656779400000017602391459585458561_);
}

.st524 {
  fill: url(#SVGID_00000179643123909819725200000018158949161466479776_);
}

.st525 {
  fill: url(#SVGID_00000043419823578385603130000016704551768466605478_);
}

.st526 {
  fill: url(#SVGID_00000065755192164674409860000003782752789528451458_);
}

.st527 {
  fill: url(#SVGID_00000176734899106581738410000012996624202745902504_);
}

.st528 {
  fill: url(#SVGID_00000116940254153751186860000012177137766452682626_);
}

.st529 {
  fill: url(#SVGID_00000169548371834724720300000010358654172798385065_);
}

.st530 {
  fill: url(#SVGID_00000080188889192512274140000008939860958325641092_);
}

.st531 {
  fill: url(#SVGID_00000154420078598011228040000009255080422015460007_);
}

.st532 {
  fill: url(#SVGID_00000059989929808140913520000008464337824204583063_);
}

.st533 {
  fill: url(#SVGID_00000022524163196875944300000011721476229608293545_);
}

.st534 {
  fill: url(#SVGID_00000111881221304309018730000012666453862541115782_);
}

.st535 {
  fill: url(#SVGID_00000021099397664332429730000008026082895627810211_);
}

.st536 {
  fill: url(#SVGID_00000026162222737178994010000002487521327724704651_);
}

.st537 {
  fill: url(#SVGID_00000015332218273696215700000000584247502468931519_);
}

.st538 {
  fill: url(#SVGID_00000183971748106842950670000017015668081091621820_);
}

.st539 {
  fill: url(#SVGID_00000115516595181942533660000014248146304620638083_);
}

.st540 {
  fill: url(#SVGID_00000136393626596027615700000010803265662477005457_);
}

.st541 {
  fill: url(#SVGID_00000078746894879540451520000012057976405618871189_);
}

.st542 {
  fill: url(#SVGID_00000114795679376143533700000008412616819327477671_);
}

.st543 {
  fill: url(#SVGID_00000056408016387175535760000012565932132228150950_);
}

.st544 {
  fill: url(#SVGID_00000075875512080441863910000012243663735230370176_);
}

.st545 {
  fill: url(#SVGID_00000000199295236329206740000015239646734915014540_);
}

.st546 {
  fill: url(#SVGID_00000095328103002664056100000004322443425874608823_);
}

.st547 {
  fill: url(#SVGID_00000155837038439505067570000007976341874275503790_);
}

.st548 {
  fill: url(#SVGID_00000094600328693151920740000004000856014328130194_);
}

.st549 {
  fill: url(#SVGID_00000183967422242540621980000001740328950286761856_);
}

.st550 {
  fill: url(#SVGID_00000026121180293887566040000011336650561474600583_);
}

.st551 {
  fill: url(#SVGID_00000023278180112844604760000015309016068363893938_);
}

.st552 {
  fill: url(#SVGID_00000175293996705355521160000001587859756738668205_);
}

.st553 {
  fill: url(#SVGID_00000157988033056617684620000005222465970270812050_);
}

.st554 {
  fill: url(#SVGID_00000112596084097977547820000015518137383002370446_);
}

.st555 {
  fill: url(#SVGID_00000054974904413541392020000017563629541144370097_);
}

.st556 {
  fill: url(#SVGID_00000055669900201241308490000011492198992581147823_);
}

.st557 {
  fill: url(#SVGID_00000063591372754227392180000012062372385290582410_);
}

.st558 {
  fill: url(#SVGID_00000178893988683285681840000004308320274206435469_);
}

.st559 {
  opacity: 0.2;
}

.st560 {
  opacity: 9.090909e-02;
}

.st561 {
  opacity: 0.1818;
}

.st562 {
  opacity: 0.2727;
}

.st563 {
  opacity: 0.3636;
}

.st564 {
  opacity: 0.4545;
}

.st565 {
  opacity: 0.5455;
}

.st566 {
  opacity: 0.6364;
}

.st567 {
  opacity: 0.7273;
}

.st568 {
  opacity: 0.8182;
}

.st569 {
  opacity: 0.9091;
}

.st570 {
  fill: url(#SVGID_00000176041454223410252420000013623066983848433280_);
}

.st571 {
  fill: url(#SVGID_00000104676303663434619200000011652961104554203572_);
}

.st572 {
  fill: url(#SVGID_00000155109651648805769370000011987639659544557992_);
}

.st573 {
  fill: url(#SVGID_00000128461550474284597550000007843588043698301850_);
}

.st574 {
  fill: url(#SVGID_00000026129626109330088720000005010443616849995949_);
}

.st575 {
  fill: #619788;
}

.st576 {
  fill: url(#SVGID_00000181078449470847468010000000557908551245885860_);
}

.st577 {
  fill: url(#SVGID_00000050622671241594494230000015958769758392436159_);
}

.st578 {
  fill: url(#SVGID_00000162338935081689554210000015394971688624041901_);
}

.st579 {
  fill: url(#SVGID_00000171677999892131026030000007284838718696656011_);
}

.st580 {
  fill: url(#SVGID_00000032635338837097796670000018159464066894671238_);
}

.st581 {
  fill: url(#SVGID_00000058575655099270496160000012809179157849626755_);
}

.st582 {
  fill: url(#SVGID_00000116225069534452955910000006594839520061202615_);
}

.st583 {
  fill: url(#SVGID_00000155136226150294660290000003818885747187593146_);
}

.st584 {
  fill: url(#SVGID_00000139270738886378935990000007469441574980686993_);
}

.st585 {
  fill: url(#SVGID_00000156558298176976262570000011166000380254515647_);
}

.st586 {
  opacity: 0.6;
  fill: #6B59A6;
}

.st587 {
  fill: url(#SVGID_00000072965858572558867040000012309632978872250256_);
}

.st588 {
  opacity: 0;
  fill: url(#SVGID_00000127765598516895442710000007544826359522608793_);
}

.st589 {
  opacity: 9.090909e-02;
  fill: url(#SVGID_00000108302568131644377660000009731346606831445144_);
}

.st590 {
  opacity: 0.1818;
  fill: url(#SVGID_00000106829005039623376630000002518502916765798038_);
}

.st591 {
  opacity: 0.2727;
  fill: url(#SVGID_00000078028023783919596960000013079691715261722295_);
}

.st592 {
  opacity: 0.3636;
  fill: url(#SVGID_00000126303787879966143450000011929654965761208225_);
}

.st593 {
  opacity: 0.4545;
  fill: url(#SVGID_00000108295808053564277330000001510308719535745449_);
}

.st594 {
  opacity: 0.5455;
  fill: url(#SVGID_00000086693651696112218220000007674445120046716833_);
}

.st595 {
  opacity: 0.6364;
  fill: url(#SVGID_00000078737527172653793900000009715274023129863318_);
}

.st596 {
  opacity: 0.7273;
  fill: url(#SVGID_00000027564754563545933760000000477383595068377021_);
}

.st597 {
  opacity: 0.8182;
  fill: url(#SVGID_00000061461549550764107510000012227224002817687197_);
}

.st598 {
  opacity: 0.9091;
  fill: url(#SVGID_00000168814726716307490960000018099284319808400569_);
}

.st599 {
  fill: url(#SVGID_00000041287696118009725100000008375326993842440098_);
}

.st600 {
  opacity: 0.7;
  fill: url(#SVGID_00000163774113821264226870000001428854370340077198_);
}

.st601 {
  opacity: 0.1;
  fill: url(#SVGID_00000178180248892111460970000008387433658050070412_);
}

.st602 {
  fill: url(#SVGID_00000063605465939865260390000017873400210379319718_);
}

.st603 {
  opacity: 0.5;
  fill: #2A2C2F;
}

.st604 {
  fill: url(#SVGID_00000172438565746567561410000016606611907939892114_);
}

.st605 {
  fill: #45494B;
}

.st606 {
  fill: #363B3D;
}

.st607 {
  fill: #5A5F60;
}

.st608 {
  fill: #35896F;
}

.st609 {
  clip-path: url(#SVGID_00000048499072373656182260000003492639625974363265_);
  enable-background: new;
}

.st610 {
  fill: #328168;
}

.st611 {
  fill: #33846B;
}

.st612 {
  fill: #35886E;
}

.st613 {
  fill: #368C71;
}

.st614 {
  fill: #379074;
}

.st615 {
  fill: #399377;
}

.st616 {
  fill: #3A977A;
}

.st617 {
  fill: #3C9B7D;
}

.st618 {
  fill: #3D9F81;
}

.st619 {
  fill: #3FA384;
}

.st620 {
  fill: #40A687;
}

.st621 {
  fill: #42AA8A;
}

.st622 {
  fill: #43AE8D;
}

.st623 {
  fill: #45B290;
}

.st624 {
  fill: #46B593;
}

.st625 {
  fill: #48B996;
}

.st626 {
  clip-path: url(#SVGID_00000071519245378788397870000013183833045689565589_);
  enable-background: new;
}

.st627 {
  clip-path: url(#SVGID_00000152951585873275452740000007766507290412920749_);
  enable-background: new;
}

.st628 {
  clip-path: url(#SVGID_00000000209652970311473950000002938025127572881052_);
  enable-background: new;
}

.st629 {
  clip-path: url(#SVGID_00000161616907645324552370000018150638123677491118_);
  enable-background: new;
}

.st630 {
  fill: #3EA081;
}

.st631 {
  clip-path: url(#SVGID_00000044144769895492537110000012802987061100438712_);
  enable-background: new;
}

.st632 {
  clip-path: url(#SVGID_00000120541917170877407000000011174801230177103766_);
  enable-background: new;
}

.st633 {
  clip-path: url(#SVGID_00000165217380842367890460000014802735139139370934_);
  enable-background: new;
}

.st634 {
  clip-path: url(#SVGID_00000147912086535031070140000005995215384125448339_);
  enable-background: new;
}

.st635 {
  clip-path: url(#SVGID_00000122691074499336028940000004133472944506280855_);
  enable-background: new;
}

.st636 {
  clip-path: url(#SVGID_00000182498581865214318270000015179747744593079218_);
  enable-background: new;
}

.st637 {
  clip-path: url(#SVGID_00000131335494061290718830000016110789607149193875_);
  enable-background: new;
}

.st638 {
  clip-path: url(#SVGID_00000039856146006847930650000005270390704323909764_);
  enable-background: new;
}

.st639 {
  fill: #3E9F81;
}

.st640 {
  fill: #2B715B;
}

.st641 {
  fill: #3D9E80;
}

.st642 {
  fill: #44B08E;
}

.st643 {
  clip-path: url(#SVGID_00000000193812080899336300000005194633653835633798_);
  enable-background: new;
}

.st644 {
  fill: #858585;
}

.st645 {
  fill: #8A8A8A;
}

.st646 {
  fill: #8F8F8F;
}

.st647 {
  fill: #949494;
}

.st648 {
  fill: #999999;
}

.st649 {
  fill: #9E9E9E;
}

.st650 {
  fill: #A3A3A3;
}

.st651 {
  fill: #A8A8A8;
}

.st652 {
  fill: #ADADAD;
}

.st653 {
  fill: #B3B3B3;
}

.st654 {
  fill: #B8B8B8;
}

.st655 {
  fill: #BDBDBD;
}

.st656 {
  fill: #C2C2C2;
}

.st657 {
  fill: #C7C7C7;
}

.st658 {
  fill: #CCCCCC;
}

.st659 {
  fill: #D1D1D1;
}

.st660 {
  fill: #D6D6D6;
}

.st661 {
  fill: #DBDBDB;
}

.st662 {
  fill: #E0E0E0;
}

.st663 {
  fill: #E6E6E6;
}

.st664 {
  fill: #EBEBEB;
}

.st665 {
  fill: #F0F0F0;
}

.st666 {
  fill: #F5F5F5;
}

.st667 {
  fill: #FAFAFA;
}

.st668 {
  clip-path: url(#SVGID_00000069387597233833078600000010054360292456616636_);
  enable-background: new;
}

.st669 {
  clip-path: url(#SVGID_00000142153734033651118480000007710686014542299549_);
  enable-background: new;
}

.st670 {
  clip-path: url(#SVGID_00000031198527734940073260000002623969145409137806_);
  enable-background: new;
}

.st671 {
  fill: #989898;
}

.st672 {
  clip-path: url(#SVGID_00000025415097259513656760000011402793563601827213_);
  enable-background: new;
}

.st673 {
  clip-path: url(#SVGID_00000088106633527595750140000003610745672747819702_);
  enable-background: new;
}

.st674 {
  fill: #D8D8D8;
}

.st675 {
  clip-path: url(#SVGID_00000011013894164386123420000001234767787976562564_);
  enable-background: new;
}

.st676 {
  clip-path: url(#SVGID_00000054229231804216366370000008907019116657505938_);
  enable-background: new;
}

.st677 {
  clip-path: url(#SVGID_00000004530468932107180370000016531553097328553130_);
  enable-background: new;
}

.st678 {
  clip-path: url(#SVGID_00000121997028107417776230000014692811579957574789_);
  enable-background: new;
}

.st679 {
  clip-path: url(#SVGID_00000174589893986440909420000005656814724986645896_);
  enable-background: new;
}

.st680 {
  clip-path: url(#SVGID_00000147185001507178628810000007764829655083212945_);
  enable-background: new;
}

.st681 {
  clip-path: url(#SVGID_00000094583424775002091030000012108471941537428915_);
  enable-background: new;
}

.st682 {
  clip-path: url(#SVGID_00000165951707800721198610000001441204380527699610_);
  enable-background: new;
}

.st683 {
  clip-path: url(#SVGID_00000129903302768293277020000003330761146690272439_);
  enable-background: new;
}

.st684 {
  clip-path: url(#SVGID_00000069380703661409349100000005944483842226349495_);
  enable-background: new;
}

.st685 {
  clip-path: url(#SVGID_00000000214953837205630360000013750689186305964456_);
  enable-background: new;
}

.st686 {
  clip-path: url(#SVGID_00000157309436064059214990000012625133951365640614_);
  enable-background: new;
}

.st687 {
  clip-path: url(#SVGID_00000106854655810896856910000003412403152598046893_);
  enable-background: new;
}

.st688 {
  clip-path: url(#SVGID_00000110462015255631412330000004854061921903724957_);
  enable-background: new;
}

.st689 {
  clip-path: url(#SVGID_00000011009177352220736960000007430923435924241853_);
  enable-background: new;
}

.st690 {
  clip-path: url(#SVGID_00000008835683429094610470000001264398679312739206_);
  enable-background: new;
}

.st691 {
  clip-path: url(#SVGID_00000079451230172947910930000008576462773144974271_);
  enable-background: new;
}

.st692 {
  clip-path: url(#SVGID_00000134940968112992805700000002331316644325738651_);
  enable-background: new;
}

.st693 {
  fill: #685AA1;
}

.st694 {
  fill: url(#XMLID_00000090987949856214700730000003171880642618818984_);
}

.st695 {
  fill: url(#XMLID_00000127043151010794427700000006531830933161959051_);
}

.st696 {
  fill: url(#XMLID_00000083056535571358891990000002767920836790871210_);
}

.st697 {
  fill: #F1F0F0;
}

.st698 {
  fill: url(#SVGID_00000011022466869926233290000000330994776535356336_);
}

.st699 {
  opacity: 0.8;
  fill: #455B64;
}

.st700 {
  fill: url(#SVGID_00000055675718016173912620000001702227437471974574_);
}

.st701 {
  fill: #3E3F6F;
}

.st702 {
  fill: #6B59A6;
}

.st703 {
  fill: #FAFBFB;
}

.st704 {
  fill: #58C2B1;
}

.st705 {
  opacity: 0.8;
  fill: #FAFBFB;
}

.st706 {
  fill: #455B64;
}

.st707 {
  opacity: 0.3;
}

.st708 {
  fill: #716F6F;
}

.st709 {
  fill: #C6C5C4;
}

.st710 {
  fill: url(#SVGID_00000111876504761109827800000009816043202511871925_);
}

.st711 {
  fill: #049AD0;
}

.st712 {
  fill: url(#SVGID_00000039129183444009136270000011793575076116831659_);
}

.st713 {
  fill: url(#SVGID_00000036228871773577758940000017269551959796284823_);
}

.st714 {
  fill: url(#SVGID_00000043459023975826235470000016895409868077480355_);
}

.st715 {
  fill: url(#SVGID_00000119834865850189734240000018302754330579203004_);
}

.st716 {
  fill: url(#SVGID_00000022527689092976627700000012046698345138651264_);
}

.st717 {
  fill: #1B6F5A;
}

.st718 {
  fill: #A382BB;
}

.st719 {
  opacity: 0.7;
  fill: #4ABD96;
}

.st720 {
  opacity: 0.6;
  fill: #1B6F5A;
}

.st721 {
  fill: url(#SVGID_00000132778018206623378970000018108852753305495469_);
}

.st722 {
  fill: url(#SVGID_00000168112325532530491340000001992084099899530132_);
}

.st723 {
  fill: url(#SVGID_00000090254951351689121210000008908739251500494499_);
}

.st724 {
  fill: url(#SVGID_00000109020113849324954520000009389028689877317552_);
}

.st725 {
  fill: url(#SVGID_00000023255052380017285750000003148669187293842106_);
}

.st726 {
  fill: url(#SVGID_00000134942325517378994030000017009954016937712038_);
}

.st727 {
  fill: #30B78D;
}

.st728 {
  fill: #F16C73;
}

.st729 {
  fill: #FDD500;
}

.st730 {
  opacity: 0.2;
  fill: #6B59A6;
}

.st731 {
  fill: url(#SVGID_00000132791732324836800640000016988101259616265141_);
}

.st732 {
  fill: url(#SVGID_00000057858593839637897210000008307557787162621312_);
}

.st733 {
  fill: url(#SVGID_00000080927333406941379340000006715217621271303339_);
}

.st734 {
  fill: url(#SVGID_00000065782296469813662660000001234756996007539859_);
}

.st735 {
  fill: url(#SVGID_00000010296689029029246670000015866654182887463298_);
}

.st736 {
  fill: url(#SVGID_00000108271452472809874740000017232598334058656650_);
}

.st737 {
  fill: #1F6F58;
}

.st738 {
  fill: url(#SVGID_00000116211106621215692600000010385079320888120248_);
}

.st739 {
  fill: url(#SVGID_00000119076521000136913950000003125502854220286910_);
}

.st740 {
  fill: url(#SVGID_00000037662091888657162880000012256988360306950048_);
}

.st741 {
  fill: url(#SVGID_00000060741321871664356850000008926188705095651201_);
}

.st742 {
  fill: url(#SVGID_00000142153243451242542180000008941629123308345518_);
}

.st743 {
  fill: url(#SVGID_00000021826811252480421490000013855462617903957917_);
}

.st744 {
  fill: #4ABD96;
}

.st745 {
  opacity: 0.1;
  fill: #4ABD96;
}

.st746 {
  opacity: 0.5;
}

.st747 {
  fill: url(#SVGID_00000085242217860168876550000002373542879793694607_);
}

.st748 {
  fill: url(#SVGID_00000113318003315536030830000012910109315971889561_);
}

.st749 {
  fill: url(#SVGID_00000150780754297879310380000014501400539294473394_);
}

.st750 {
  fill: #30302F;
}

.st751 {
  fill: url(#SVGID_00000036962295470403661630000017957438215895079356_);
}

.st752 {
  fill: url(#SVGID_00000026885444879441342740000010650460895939134652_);
}

.st753 {
  fill: url(#SVGID_00000101098466948324650170000017652998754159714733_);
}

.st754 {
  fill: url(#SVGID_00000003802559546991922640000008170924985552982665_);
}

.st755 {
  fill: url(#SVGID_00000016778900714931034300000004163797035681120393_);
}

.st756 {
  fill: url(#SVGID_00000139264959609047452940000004733300982318379431_);
}

.st757 {
  opacity: 0.5;
  fill: #FFFFFF;
}

.st758 {
  fill: url(#SVGID_00000155109602545786617300000006672446691257143683_);
}
</style>